var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as e from "react";
import * as t from "uitk-react-pill";
import * as a from "uitk-react-utils";
import * as i from "uitk-react-icons";
import * as s from "throttle-debounce";
import * as n from "@shared-ui/localization-context";
import * as l from "@shared-ui/viewport-context";
import * as r from "uitk-react-input";
import * as o from "uitk-react-button";
import * as c from "uitk-react-layout-flex";
import * as d from "uitk-react-scrim";
import * as u from "uitk-react-sheet";
import * as h from "uitk-react-toolbar";
import * as m from "uitk-react-action-list-item";
import * as p from "uitk-react-text";
import * as g from "uitk-react-spacing";
import * as y from "uitk-react-skeleton";
import * as f from "tslib";
import * as R from "normalize-text";
import * as v from "@shared-ui/dialog-context";
var T = {
    197: () => {},
    904: () => {}
  },
  E = {};
function S(e) {
  var t = E[e];
  if (void 0 !== t) return t.exports;
  var a = E[e] = {
    exports: {}
  };
  return T[e](a, a.exports, S), a.exports;
}
S.n = e => {
  var t = e && e.__esModule ? () => e.default : () => e;
  return S.d(t, {
    a: t
  }), t;
}, S.d = (e, t) => {
  for (var a in t) S.o(t, a) && !S.o(e, a) && Object.defineProperty(e, a, {
    enumerable: !0,
    get: t[a]
  });
}, S.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), (() => {
  var e;
  if ("string" == typeof import.meta.url && (e = import.meta.url), !e) throw new Error("Automatic publicPath is not supported in this browser");
  e = e.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), S.p = e + "../";
})();
var b = {};
(() => {
  S.d(b, {
    cV: () => $,
    n7: () => ie,
    hI: () => N,
    Le: () => M,
    CG: () => Je,
    Ow: () => vt,
    r: () => te,
    AI: () => Ze,
    LG: () => D
  });
  const T = (E = {
    Children: () => e.Children,
    Component: () => e.Component,
    Fragment: () => e.Fragment,
    cloneElement: () => e.cloneElement,
    createElement: () => e.createElement,
    createRef: () => e.createRef,
    default: () => e.default,
    isValidElement: () => e.isValidElement,
    useContext: () => e.useContext,
    useEffect: () => e.useEffect,
    useMemo: () => e.useMemo,
    useRef: () => e.useRef,
    useState: () => e.useState
  }, k = {}, S.d(k, E), k);
  var E, k;
  const I = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkPillContainer: () => t.UitkPillContainer,
      UitkRemovablePill: () => t.UitkRemovablePill
    }),
    w = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkContextWrapper: () => a.UitkContextWrapper,
      classNames: () => a.classNames,
      initGoogleMapsApi: () => a.initGoogleMapsApi,
      isElementVisible: () => a.isElementVisible,
      liveAnnounce: () => a.liveAnnounce
    }),
    x = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkIcon: () => i.UitkIcon,
      UitkIconSize: () => i.UitkIconSize
    }),
    A = S.p + "./styles/egds-search-experience-single-select-pill-wrapper.css",
    C = w.classNames.bind(A),
    U = ({
      active: e,
      altText: t,
      checked: a = !1,
      className: i,
      disabled: s,
      icon: n,
      id: l,
      name: r,
      onChange: o,
      selected: c,
      text: d,
      value: u
    }) => {
      const h = "single-select-pill",
        m = C(h, i, {
          [`${h}-disabled`]: s
        }),
        p = C(`${h}-content`, {
          [`${h}-active`]: e,
          [`${h}-selected`]: c
        }),
        g = u !== null && u !== void 0 ? u : `${a}`;
      return T.default.createElement("div", {
        className: m
      }, T.default.createElement("input", {
        id: l,
        name: r,
        checked: a,
        "aria-checked": a,
        type: "radio",
        onChange: o,
        className: C(`${h}-standard is-visually-hidden`),
        disabled: s,
        value: g
      }), T.default.createElement("label", {
        className: p,
        htmlFor: l,
        "aria-label": t
      }, n && T.default.createElement(x.UitkIcon, {
        className: C(`${h}-icon`),
        name: n
      }), T.default.createElement("span", {
        className: C(`${h}-text`)
      }, d)));
    };
  U.displayName = "SingleSelectPill";
  const N = ({
    data: e,
    handleSelectedPill: t
  }) => {
    const a = e => {
        const a = e.target.value;
        t(a);
      },
      i = w.classNames.bind(A);
    return T.default.createElement(I.UitkPillContainer, {
      className: i("single-select-pill-wrapper")
    }, e.map(_a => {
      var {
          id: e,
          selected: t
        } = _a,
        i = __rest(_a, ["id", "selected"]);
      return T.default.createElement(U, Object.assign(Object.assign({
        id: e,
        key: e
      }, i), {
        selected: t,
        checked: t,
        onChange: a
      }));
    }));
  };
  N.displayName = "SingleSelectPillWrapper";
  const L = S.p + "./styles/egds-search-experience-view-row.css",
    D = ({
      children: e,
      className: t,
      adSlot: a = !1,
      canvasTheme: i = "primary",
      layout: s = "fullwidth",
      paddedViewRow: n = !0,
      maxWidth: l = !1
    }) => {
      const r = w.classNames.bind(L)("view-row", `view-row-theme-${i}`, `view-row-layout-${s}`, `view-row-padded-${n}`, !l && `view-row-adslot-${a}`, t);
      return T.default.createElement("div", {
        className: r,
        "data-testid": "view-row"
      }, e);
    };
  D.displayName = "ViewRow";
  const P = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      debounce: () => s.debounce,
      throttle: () => s.throttle
    }),
    z = S.p + "./styles/egds-search-experience-sticky.css",
    O = w.classNames.bind(z),
    M = e => {
      const [t, a] = T.useState(!1),
        [i, s] = T.useState(),
        [n, l] = T.useState(),
        r = "sticky",
        o = T.useRef(),
        {
          zIndex: c,
          hidden: d,
          children: u,
          toggleBgColor: h,
          defaultPadding: m
        } = e,
        p = O(r, {
          [`${r}-hidden`]: d
        }, {
          [`${r}-fixed`]: t
        }),
        g = {
          height: d ? 0 : i
        },
        y = {
          width: n,
          zIndex: c || 1
        };
      T.useEffect(() => {
        const {
          enableStickyWhenNotInViewport: t
        } = e;
        let i, n;
        const r = {
            threshold: t ? 0 : 1
          },
          c = (0, P.throttle)(100, !1, () => {
            if (o.current) {
              const {
                height: e,
                width: t
              } = o.current.getBoundingClientRect();
              s(e), l(t);
            }
          }, !1);
        return "ResizeObserver" in window && (n = new ResizeObserver(() => {
          c();
        }), n.observe(o.current)), n || window.addEventListener("resize", c), "IntersectionObserver" in window && (i = new IntersectionObserver(i => {
          var _a;
          const {
              onFixed: n
            } = e,
            r = i.shift(),
            o = !r || (t ? !(r === null || r === void 0 ? void 0 : r.isIntersecting) : ((_a = r.boundingClientRect) === null || _a === void 0 ? void 0 : _a.top) < 0);
          a(o), s(r ? r.boundingClientRect.height : "auto"), l(r ? r.boundingClientRect.width : "100%"), n && n(o);
        }, r), i.observe(o.current)), () => {
          i && i.unobserve(o.current), n ? n.unobserve(o.current) : window.removeEventListener("resize", c);
        };
      }, [e]);
      const f = O("sticky-row", `${t && "sticky-row-theme-primary"}`, `sticky-row-padded-${t || m}`);
      return T.createElement("div", {
        ref: o,
        className: p,
        style: g
      }, T.createElement("div", {
        className: O(`${r}-inner`),
        style: y
      }, h ? T.createElement("div", {
        className: f
      }, u) : T.createElement(T.Fragment, null, u)));
    },
    F = S.p + "./styles/egds-search-experience-button-toggle-custom-content.css",
    _ = w.classNames.bind(F),
    $ = e => {
      const {
          children: t,
          checked: a,
          className: i,
          disabled: s,
          id: n,
          name: l,
          onChange: r
        } = e,
        o = __rest(e, ["children", "checked", "className", "disabled", "id", "name", "onChange"]),
        c = "button-toggle-custom-content",
        d = _(c, i, {
          [`${c}-is-checked`]: a,
          [`${c}-is-disabled`]: s
        }),
        u = _(`${c}-container`),
        h = _(`${c}-input`, "is-visually-hidden");
      return T.createElement("div", {
        className: d
      }, T.createElement("label", {
        className: u,
        htmlFor: n
      }, T.createElement("input", Object.assign({
        id: n,
        name: l,
        type: "checkbox",
        onChange: r,
        className: h,
        disabled: s,
        checked: a,
        "aria-checked": a,
        value: a ? "true" : "false"
      }, o)), t));
    };
  $.displayName = "ButtonToggleCustomContent";
  const V = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      useLocalization: () => n.useLocalization
    }),
    B = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      ViewLarge: () => l.ViewLarge,
      ViewSmall: () => l.ViewSmall,
      Viewport: () => l.Viewport
    }),
    K = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkFakeInput: () => r.UitkFakeInput,
      UitkInput: () => r.UitkInput,
      UitkTextInput: () => r.UitkTextInput
    }),
    H = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkButton: () => o.UitkButton,
      UitkButtonSize: () => o.UitkButtonSize,
      UitkFloatingFullWidthButton: () => o.UitkFloatingFullWidthButton,
      UitkPrimaryButton: () => o.UitkPrimaryButton,
      UitkTertiaryButton: () => o.UitkTertiaryButton
    }),
    W = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkLayoutFlex: () => c.UitkLayoutFlex,
      UitkLayoutFlexItem: () => c.UitkLayoutFlexItem
    }),
    G = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkScrim: () => d.UitkScrim,
      UitkScrimType: () => d.UitkScrimType
    }),
    Y = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkSheet: () => u.UitkSheet,
      UitkSheetContent: () => u.UitkSheetContent,
      UitkSheetTransition: () => u.UitkSheetTransition
    }),
    q = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkToolbar: () => h.UitkToolbar
    });
  class j {
    constructor(e) {
      this.locale = e;
    }
    toEssResult(e, t, a) {
      const i = e;
      let s = "",
        n = "";
      const l = (i || "").split(",");
      return l.length < 2 ? s = l[0].trim() : (s = l[0], n = l.slice(1).map(e => e.trim()).join(", ").trim()), {
        category: this.category,
        coordinates: void 0,
        index: a,
        regionNames: {
          displayName: i,
          fullName: e,
          lastSearchName: e,
          primaryDisplayName: s,
          secondaryDisplayName: n
        },
        sourceId: t,
        sourceName: this.sourceName,
        type: this.type
      };
    }
  }
  const Q = "GOOGLEMAPS";
  var Z;
  !function (e) {
    e.INVALID_REQUEST = "INVALID_REQUEST", e.OK = "OK", e.OVER_QUERY_LIMIT = "OVER_QUERY_LIMIT", e.REQUEST_DENIED = "REQUEST_DENIED", e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.ZERO_RESULTS = "ZERO_RESULTS";
  }(Z || (Z = {}));
  class J extends j {
    constructor(e, t, a) {
      super(e), this.category = Q, this.sourceName = "GPA", this.type = "ADDRESS", this.version = a;
      const i = {
          accessToken: t,
          locale: e,
          version: a
        },
        s = new Promise((e, t) => {
          setTimeout(() => {
            t(new Error("Timeout: Map API initialization took too long"));
          }, 1e4);
        });
      this.ready = Promise.race([(0, w.initGoogleMapsApi)(!1, i, !1), s]).then(() => (this.google = window.google, this.initGooglePlacesService(), !0)).catch(e => (console.error(e), !1));
    }
    static getInstance(e, t, a) {
      const i = e || "en_US",
        s = t || "AIzaSyABOFQNLMiTVN0AG3eWNmspVfVC8gNda68";
      return i in this.instances || (this.instances[i] = new J(i, s, a)), this.instances[i];
    }
    isReady() {
      return this.ready;
    }
    initGooglePlacesService() {
      if (this.google && this.google.maps && this.google.maps.places) {
        const {
          AutocompleteService: e,
          PlacesService: t
        } = this.google.maps.places;
        this.googleAutoCompleteService = new e(), this.placesService = new t(document.createElement("div"));
      }
    }
    fetchResults(e) {
      const t = {
        input: e.q,
        type: "ADDRESS_AUTOCOMPLETE" === e.rc ? ["geocode"] : void 0
      };
      return new Promise(a => {
        this.googleAutoCompleteService ? this.googleAutoCompleteService.getPlacePredictions(t, (t, i) => {
          if (i === Z.OK) {
            const i = (s = this.handleResponse(t), {
              q: e.q,
              rc: e.rc,
              rid: e.rid,
              sr: s
            });
            a(i);
          } else a(e);
          var s;
        }) : a(e);
      });
    }
    fetchLocation(e) {
      return this.isReady().then(t => new Promise((a, i) => {
        if (0 == !t) try {
          const t = {
            placeId: e,
            fields: ["geometry"]
          };
          this.placesService.getDetails(t, (t, s) => {
            var _a;
            if (s === Z.OK) {
              const e = (_a = t === null || t === void 0 ? void 0 : t.geometry) === null || _a === void 0 ? void 0 : _a.location;
              a(e ? {
                lat: e.lat().toFixed(5),
                lng: e.lng().toFixed(5)
              } : void 0);
            } else s === Z.ZERO_RESULTS ? a(void 0) : i(new Error(`Failed to fetch location for placeId ${e}: ${s}`));
          });
        } catch (t) {
          i(new Error(`Failed to fetch location for placeId ${e}: ${t.message}`));
        } else i(new Error(`Unable to fetch location for placeId ${e}: PlacesService is not initialized`));
      }));
    }
    handleResponse(e) {
      const t = [];
      return e.forEach((e, a) => {
        t.push(this.toEssResult(e.description, e.place_id, a));
      }), t;
    }
  }
  J.instances = {};
  const X = {
    google: J
  };
  class ee {
    static getInstance(e, t, a, i) {
      return X[e].getInstance(t, a, i);
    }
    static filterThirdPartyAdapterFromEssConfig(e) {
      return e.filter(e => e in X);
    }
  }
  var te, ae;
  !function (e) {
    e.HOTEL = "HOTEL", e.AIRPORT = "AIRPORT", e.MULTICITY = "MULTICITY", e.POI = "POI", e.METROCODE = "METROCODE", e.METROSTATION = "METROSTATION", e.TRAINSTATION = "TRAINSTATION", e.ADDRESS = "ADDRESS", e.NEIGHBORHOOD = "NEIGHBORHOOD", e.CURRENT_LOCATION = "CURRENT_LOCATION", e.PREMISE = "PREMISE", e.BUSSTATION = "BUSSTATION", e.ACTIVITY = "ACTIVITY", e.ATTRACTION = "ATTRACTION", e.CITY = "CITY";
  }(te || (te = {})), function (e) {
    e.GOOGLE = "google", e.CONSISTENT_DISPLAY = "consistent_display";
  }(ae || (ae = {}));
  class ie {
    constructor(e) {
      this.viewSize = 0;
      this.isGeoLocationAllowed = !0;
      this.config = e, this.config.getDevice = this.getDevice;
    }
    setTypeaheadCategories() {
      const {
        formatText: e
      } = this.l10n;
      this.ESSCategories = {
        ACTIVITY: e("typeahead.ess.attraction"),
        ADDRESS: e("typeahead.ess.address"),
        AIRPORT: e("typeahead.ess.airport"),
        ATTRACTION: e("typeahead.ess.attraction"),
        BUSSTATION: e("typeahead.ess.transit"),
        CITY: e("typeahead.ess.city"),
        HOTEL: e("typeahead.ess.hotel"),
        LISTING: e("typeahead.ess.property"),
        METROCODE: e("typeahead.ess.city"),
        METROSTATION: e("typeahead.ess.transit"),
        MULTICITY: e("typeahead.ess.city"),
        MULTIREGION: e("typeahead.ess.city"),
        NEIGHBORHOOD: e("typeahead.ess.city"),
        POI: e("typeahead.ess.attraction"),
        PREMISE: e("typeahead.ess.property"),
        TRAINSTATION: e("typeahead.ess.transit"),
        CURRENT_LOCATION: ""
      };
    }
    isHistoryDetailEnabled() {
      return !0 === this.config.historyDetail;
    }
    getConfig() {
      return this.config;
    }
    getTypeaheadCategories() {
      return this.ESSCategories;
    }
    addToESSCategories(e) {
      this.ESSCategories = Object.assign(Object.assign({}, this.ESSCategories), e);
    }
    setL10n(e) {
      this.l10n = e;
    }
    createURLParams(e) {
      return Object.entries(e).map(([e, t]) => `${e}=${encodeURIComponent(t)}`).join("&");
    }
    fetchDeleteRecentSearch(e) {
      const t = `${this.config.domain.endsWith("/") ? this.config.domain : `${this.config.domain}/`}api/v1/deletehistory`,
        a = {
          lob: this.config.lob,
          locale: this.config.locale,
          guid: this.config.guid,
          expuserid: this.config.expuserid,
          siteId: this.config.siteId,
          dest: this.config.dest
        },
        i = `${t}?${this.createURLParams(a)}`,
        s = new Headers({
          accept: "application/json",
          "Content-Type": "application/json"
        });
      if ("" !== e) {
        const t = {
          gaiaIds: [e]
        };
        return fetch(i, {
          body: JSON.stringify(t),
          headers: s,
          method: "POST"
        }).then(e => e.json()).catch(e => {
          console.error(`Error while deleting recent searches: ${e}`);
        });
      }
      return Promise.resolve([]);
    }
    constructURL(e, t) {
      let a = this.config.domain ? this.config.domain : "";
      a = a.endsWith("/") ? a : `${a}/`, a.endsWith("/") && (a = a.slice(0, -1));
      const i = (() => "AIRLINE" === this.config.domainId ? `${a}/api/v2/suggest` : `${a}/api/v4/typeahead`)();
      if (void 0 !== this.config.browser && null !== this.config.browser || (this.config.browser = this.getBrowser(window.navigator.userAgent)), void 0 !== this.config.device && null !== this.config.device || (this.config.device = this.getDevice(window.navigator.userAgent)), "AIRLINE" === this.config.domainId) {
        const t = {
          domainId: this.config.domainId,
          lob: this.config.lob,
          maxResults: this.config.maxResults,
          siteid: this.config.siteId,
          locale: this.config.locale
        };
        return `${i}?query=${e}&${this.createURLParams(t)}`;
      }
      const s = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        browser: this.config.browser,
        client: this.config.client,
        dest: this.config.dest,
        device: this.config.device,
        expuserid: this.config.expuserid ? this.config.expuserid : -1,
        features: this.config.features,
        format: "json",
        guid: this.config.guid,
        listing: !!this.config.listing,
        lob: this.config.lob,
        locale: this.config.locale,
        maxresults: this.config.maxResults,
        personalize: !!this.config.personalize && this.config.personalize
      }, this.config.regionId ? {
        rid: this.config.regionId
      } : {}), {
        regiontype: this.config.regionType,
        siteid: this.config.siteId,
        ignorePrefillSearchTermForAlternateDestinationsRequest: this.config.ignorePrefillSearchTermForAlternateDestinationsRequest
      }), this.config.packageType ? {
        pt: this.config.packageType
      } : {}), this.config.latLong ? {
        latlong: this.config.latLong
      } : {}), this.config.lastSearchRegionId ? {
        lsrid: this.config.lastSearchRegionId
      } : {}), this.config.lastSearchTimestamp ? {
        lstime: this.config.lastSearchTimestamp
      } : {}), this.config.lastSearchLatLong ? {
        lslatlong: this.config.lastSearchLatLong
      } : {}), this.config.lastSearchElapseTime ? {
        lsetime: this.config.lastSearchElapseTime
      } : {}), this.config.googleApiKey ? {
        googleApiKey: this.config.googleApiKey
      } : {}), this.config.googleApiVersion ? {
        googleApiVersion: this.config.googleApiVersion
      } : {}), this.config.alternate && t ? {
        alternate: !0
      } : {}), this.config.debounceVariant ? {
        ab: this.config.debounceVariant
      } : {}), this.config.trending ? {
        trending: this.config.trending
      } : {}), this.config.alternateSecondVariant ? {
        alternateSecondVariant: this.config.alternateSecondVariant
      } : {}), this.config.drivable ? {
        drivable: this.config.drivable
      } : {}), this.config.fetchLocation ? {
        fetchLocation: this.config.fetchLocation
      } : {}), this.config.popularFilter ? {
        popularFilter: this.config.popularFilter
      } : {});
      return "" === e ? `${i}/?${this.createURLParams(s)}` : `${i}/${e}?${this.createURLParams(s)}`;
    }
    fetchResponse(e, t) {
      var _a, _b;
      const a = this.config && this.config.personalize;
      return "" === e && a || "" !== e ? ((_b = (_a = this.config).logRequest) === null || _b === void 0 ? void 0 : _b.call(_a, e), fetch(this.constructURL(e, t), Object.assign({
        method: "AIRLINE" === this.config.domainId ? "POST" : "GET"
      }, this.config.xPageId && {
        headers: {
          "x-page-id": this.config.xPageId
        }
      })).then(e => e.json())) : Promise.resolve([]);
    }
    fetchResults(e, t) {
      const a = t ? "" : e;
      return this.fetchResponse(a, t).then(e => this.handleEssResponse(e)).then(e => this.logResponse(e)).then(e => this.adaptResponseToTypeaheadResults(e, a, this.config.historyDetail, this.config.historyDetailFormatVariant)).then(e => this.categorizeOnFocusResponse(e, t));
    }
    fetchRecentSearchResults() {
      return this.fetchResults("");
    }
    fetchAlternativeResults(e) {
      return this.fetchResults(e, this.config.alternate || this.config.ignorePrefillSearchTermForAlternateDestinationsRequest);
    }
    fetchResultsCategorized(e) {
      return this.fetchResponse(e).then(e => this.handleEssResponse(e)).then(e => this.logResponse(e)).then(t => this.adaptResponseToTypeaheadResults(t, e, this.config.historyDetail, this.config.historyDetailFormatVariant)).then(e => this.categorizeResponse(e));
    }
    fetchRecentSearchResultsCategorized() {
      return this.fetchResultsCategorized("");
    }
    categorizeResponse(e) {
      const t = new Map(),
        a = [];
      let i = 0;
      if (e && e.length > 0) {
        e.forEach(e => {
          var _a;
          const a = ((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.type) ? this.ESSCategories[e.data.type] : "";
          t[a] || (t[a] = []), t[a].push(e);
        });
        for (const [e, s] of Object.entries(t)) {
          s.forEach(e => {
            e.data.index = i, i++;
          });
          const t = {
            heading: e,
            typeaheadResults: s
          };
          a.push(t);
        }
      }
      return a;
    }
    onFocusCategories() {
      const {
        formatText: e
      } = this.l10n;
      return Object.assign({
        CURRENTLOCATION: "",
        POPULAR: e("typeahead.ess.popular") || "Explore popular destinations",
        DRIVABLE: e("typeahead.ess.nearby") || "Nearby locations"
      }, this.config.alternateSecondVariant ? {
        USERHISTORY: e("typeahead.ess.history") || "Recent searches",
        ALTERNATE: e("typeahead.ess.alternate") || "People also searched"
      } : {
        ALTERNATE: e("typeahead.ess.alternate") || "People also searched",
        USERHISTORY: e("typeahead.ess.history") || "Recent searches"
      });
    }
    categorizeOnFocusResponse(e, t) {
      var _a, _b;
      if (e && e.length > 0) {
        const a = e[0];
        if ("ALTERNATE" === a.data.category || "CURRENTLOCATION" === a.data.category || "POPULAR" === a.data.category || "DRIVABLE" === a.data.category && this.config.drivable || "USERHISTORY" === a.data.category && this.config.alternate && t) {
          const a = new Map(),
            i = [],
            s = this.onFocusCategories();
          let n = 0;
          e.forEach(e => {
            if (e.data.category) {
              const t = e.data.category;
              a[t] || (a[t] = []), a[t].push(e);
            }
          });
          for (const [e, t] of Object.entries(s)) {
            const s = a[e];
            if (s && s.length > 0) {
              s.forEach(e => {
                e.data.index = n, e.data.displayType = "CATEGORIZED", n += 1;
              });
              const e = {
                heading: t,
                typeaheadResults: s
              };
              i.push(e);
            }
          }
          return (t || this.config.showCurrentLocation) && (this.response.sr = i.flatMap(e => e.typeaheadResults.map(e => e.data)), (_b = (_a = this.config).logResponse) === null || _b === void 0 ? void 0 : _b.call(_a, this.response)), i;
        }
      }
      return e;
    }
    onItemSelection(e) {
      return (e === null || e === void 0 ? void 0 : e.type) === te.CURRENT_LOCATION ? this.handleCurrentLocationSelection(e) : this.config.fetchLocation && (e === null || e === void 0 ? void 0 : e.type) === te.ADDRESS && e.category === Q && e.sourceId && "function" == typeof this.thirdPartyFallbackAdapter.fetchLocation ? this.fillLocation(this.thirdPartyFallbackAdapter.fetchLocation.bind(this.thirdPartyFallbackAdapter), e.sourceId, e) : Promise.resolve(e);
    }
    handleCurrentLocationSelection(e) {
      if (this.isGeoLocationAllowed) return this.readCurrentLocation().then(({
        coords: {
          latitude: t,
          longitude: a
        }
      }) => Object.assign(Object.assign({}, e), {
        location: {
          lat: t.toFixed(5),
          long: a.toFixed(5)
        }
      })).catch(e => {
        throw this.isGeoLocationAllowed = !1, e;
      });
      const t = this.l10n.formatText("typeahead.currentLocation.blocked.message");
      return window.alert(t), Promise.reject(t);
    }
    fillLocation(e, t, a) {
      return e(t).then(e => {
        if (e) {
          const {
            lat: t,
            lng: i
          } = e;
          return Object.assign({
            location: {
              lat: t,
              long: i
            }
          }, a);
        }
        return a;
      });
    }
    readCurrentLocation() {
      return new Promise((e, t) => {
        window.navigator.geolocation.getCurrentPosition(e, t);
      });
    }
    handleEssResponse(e) {
      return e.sr = e.sr || e.suggestions || [], this.thirdPartyFallbackAdapter || this.setThirdPartyAdapter(), !this.thirdPartyFallbackAdapter || "GOOGLE_AUTOCOMPLETE" !== e.rc && "ADDRESS_AUTOCOMPLETE" !== e.rc ? Promise.resolve(e) : this.thirdPartyFallbackAdapter.fetchResults(e);
    }
    setThirdPartyAdapter() {
      const e = ee.filterThirdPartyAdapterFromEssConfig(this.config.features.split("|"));
      let t;
      if (e.length > 0) {
        const a = e[0];
        t = ee.getInstance(a, this.config.locale, "google" === a ? this.config.googleApiKey : void 0, "google" === a ? this.config.googleApiVersion : void 0), this.thirdPartyFallbackAdapter = t;
      }
    }
    logResponse(e) {
      var _a, _b;
      return (_b = (_a = this.config).logResponse) === null || _b === void 0 ? void 0 : _b.call(_a, e), this.response = e, Promise.resolve(e);
    }
    adaptResponseToTypeaheadResults(e, t, a, i) {
      var _a, _b;
      const s = (e, t, a, i) => i ? e("typeahead.recentHistory.travelers", a) : e("typeahead.recentHistory.roomsTravelers", t, a),
        n = e => "LISTING" === (e === null || e === void 0 ? void 0 : e.type) && e.listingProps ? e.listingProps.headline : void 0,
        l = e => "LISTING" === (e === null || e === void 0 ? void 0 : e.type) && e.listingProps ? `${e.listingProps.listingId} - ${e.listingProps.baseLocation}` : void 0,
        r = (e, n) => {
          let l;
          if ("USERHISTORY" === e && a && void 0 !== this.l10n && n && n.searchDetail && n.searchDetail.lob && !t) {
            let e = "";
            const t = n.searchDetail,
              {
                formatDateString: a,
                formatText: r
              } = this.l10n,
              o = t.roomCount,
              c = t.lob,
              d = n.searchDetail.totalTravelerCount ? Number(n.searchDetail.totalTravelerCount) : null;
            if (n.searchDetail.startDate && n.searchDetail.endDate) {
              const n = new Date(t.startDate),
                u = 6e4 * n.getTimezoneOffset(),
                h = a(new Date(n.getTime() + u), {
                  skeleton: "MMMd"
                }),
                m = new Date(t.endDate),
                p = 6e4 * m.getTimezoneOffset(),
                g = a(new Date(m.getTime() + p), {
                  skeleton: "MMMd"
                }),
                y = r("datePicker.nightSummary", (Number(t.endDate) - Number(t.startDate)) / 864e5);
              l = `${h} - ${g}`, 1 !== o || "Lodging" !== c && "Package" !== c ? "Lodging" !== c && "Package" !== c || (l = i ? `${h}-${g}` : `${h} - ${g} | ${y}`) : (e = s(r, o, d, this.config.excludeRoomsLabelForRecentHistory), l = i ? `${h}-${g} • ${e}` : `${h} - ${g} | ${y} | ${e}`);
            } else n.searchDetail.startDate || n.searchDetail.endDate || 1 !== o || "Lodging" !== c && "Package" !== c || (l = s(r, o, d, this.config.excludeRoomsLabelForRecentHistory));
          }
          return l;
        },
        o = e => {
          var _a, _b, _c, _d, _f;
          const t = r(e.category, e) || l(e);
          if (this.config.features.indexOf(ae.CONSISTENT_DISPLAY) < 0) return {
            primaryText: ((_a = e.regionNames) === null || _a === void 0 ? void 0 : _a.displayName) || ((_b = e.names) === null || _b === void 0 ? void 0 : _b.displayName) || n(e),
            subtext: t
          };
          const a = ((_c = e.regionNames) === null || _c === void 0 ? void 0 : _c.primaryDisplayName) || ((_d = e.names) === null || _d === void 0 ? void 0 : _d.displayName) || n(e);
          return t ? {
            primaryText: `<strong>${a}</strong>`,
            subtext: t
          } : {
            primaryText: `<strong>${a}</strong>`,
            subtext: ((_f = e.regionNames) === null || _f === void 0 ? void 0 : _f.secondaryDisplayName) || l(e) || ""
          };
        },
        c = (e, t, a, i, s) => {
          if ("AIRLINE" === e) return "";
          if (a && !i) return "subdirectory_arrow_right";
          if ("USERHISTORY" === s) return "history";
          if ("FLIGHTS" === this.config.lob) return "lob_flights";
          switch (e) {
            case "HOTEL":
              return "lob_hotels";
            case "AIRPORT":
              return "lob_flights";
            case "ADDRESS":
              return "RENTALLOCATION" === t ? "lob_cars" : "place";
            case "METROSTATION":
            case "TRAINSTATION":
              return "train";
            default:
              return "place";
          }
        },
        d = "" === t && this.shouldShowCurrentLocation() ? [this.getCurrentLocationItem()] : [];
      return u = e, ((_b = (_a = u.sr) === null || _a === void 0 ? void 0 : _a.reduce) === null || _b === void 0 ? void 0 : _b.call(_a, (e, a, i) => {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const s = a.hierarchyInfo && a.hierarchyInfo.relation && a.hierarchyInfo.relation.indexOf("nearby") > -1,
          n = a.hierarchyInfo && a.hierarchyInfo.relation && a.hierarchyInfo.relation.indexOf("child") > -1 || s,
          {
            primaryText: l,
            subtext: r
          } = o(a),
          d = Object.assign(Object.assign({
            data: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, a.category ? {
              category: a.category
            } : {}), !t && a.searchDetail ? {
              searchDetail: a.searchDetail
            } : {}), a.userHistoryType ? {
              userHistoryType: a.userHistoryType
            } : {}), ((_a = a.ids) === null || _a === void 0 ? void 0 : _a.id) ? {
              id: a.ids.id
            } : {}), a.coordinates ? {
              location: {
                lat: a.coordinates.lat,
                long: a.coordinates.long
              }
            } : {}), a.regionId ? {
              regionId: a.regionId
            } : a.gaiaId ? {
              regionId: a.gaiaId
            } : {}), a.cityId ? {
              cityId: a.cityId
            } : {}), a.regionNames ? {
              regionNames: a.regionNames
            } : {}), a.type ? {
              type: a.type
            } : {}), a.subtype ? {
              subtype: a.subtype
            } : {}), a.hotelId ? {
              selected: a.hotelId
            } : {}), a.hierarchyInfo ? {
              hierarchyInfo: a.hierarchyInfo
            } : {}), "LISTING" === a.type && a.listingProps ? {
              listing: a.listingProps
            } : {}), a.sourceId ? {
              sourceId: a.sourceId
            } : {}), a.essId ? {
              essId: {
                sourceId: a.essId.sourceId,
                sourceName: a.essId.sourceName
              }
            } : {}), {
              dest: this.config.dest,
              index: i + 1
            }),
            icon: c(a.type || a.domainId, a.subtype, n, s, a.category)
          }, n ? {
            isChild: !0
          } : {}), {
            name: l,
            subtext: r,
            title: ((_b = a.regionNames) === null || _b === void 0 ? void 0 : _b.lastSearchName) || ((_c = a.regionNames) === null || _c === void 0 ? void 0 : _c.shortName) || ((_d = a.regionNames) === null || _d === void 0 ? void 0 : _d.fullName) || ((_f = a.listingProps) === null || _f === void 0 ? void 0 : _f.listingId) || ((_g = a.ids) === null || _g === void 0 ? void 0 : _g.id),
            value: ((_h = a.regionNames) === null || _h === void 0 ? void 0 : _h.lastSearchName) || ((_j = a.regionNames) === null || _j === void 0 ? void 0 : _j.shortName) || ((_k = a.regionNames) === null || _k === void 0 ? void 0 : _k.fullName) || ((_l = a.listingProps) === null || _l === void 0 ? void 0 : _l.listingId) || ((_m = a.names) === null || _m === void 0 ? void 0 : _m.displayName)
          });
        return e.push(d), (a === null || a === void 0 ? void 0 : a.filterRefinements) && ((_o = a === null || a === void 0 ? void 0 : a.filterRefinements) === null || _o === void 0 ? void 0 : _o.length) > 0 && ((_q = (_p = a === null || a === void 0 ? void 0 : a.filterRefinements.find(e => {
          var _a, _b;
          return "popularFilter" === ((_a = e === null || e === void 0 ? void 0 : e.category) === null || _a === void 0 ? void 0 : _a.legacyId) || "popular_group" === ((_b = e === null || e === void 0 ? void 0 : e.category) === null || _b === void 0 ? void 0 : _b.externalId);
        })) === null || _p === void 0 ? void 0 : _p.arrayOfValues) === null || _q === void 0 ? void 0 : _q.forEach(t => {
          e.push(Object.assign(Object.assign({}, d), {
            data: Object.assign(Object.assign({}, d.data), {
              popularFilter: [t]
            }),
            subtext: `<strong>${t === null || t === void 0 ? void 0 : t.displayName}</strong>`,
            icon: "subdirectory_arrow_right"
          }));
        })), e;
      }, d)) || d;
      var u;
    }
    shouldShowCurrentLocation() {
      return Boolean(this.config.showCurrentLocation && "geolocation" in navigator);
    }
    getCurrentLocationItem() {
      const e = this.isGeoLocationAllowed ? this.l10n.formatText("typeahead.currentLocation.available.item") : this.l10n.formatText("typeahead.currentLocation.blocked.item");
      return {
        data: {
          category: "CURRENTLOCATION",
          hierarchyInfo: {
            relation: ["current"]
          },
          index: -1,
          enabled: this.isGeoLocationAllowed,
          regionNames: {
            fullName: "CurrentLocation"
          },
          type: te.CURRENT_LOCATION
        },
        icon: "my_location",
        name: e,
        title: e,
        value: e
      };
    }
    getBrowser(e) {
      let t,
        a = e.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      return /trident/i.test(a[1]) ? "IE" : "Chrome" === a[1] && (t = e.match(/\b(OPR|Edge?)\/(\d+)/), null !== t) ? t.slice(1, -1).join(" ").replace("OPR", "Opera").replace("Edg ", "Edge ") : (a = a[2] ? [a[1], a[2]] : [navigator.appName, navigator.appVersion, "-?"], t = e.match(/version\/(\d+)/i), null !== t && a.splice(1, 1, t[1]), a[0]);
    }
    getDevice(e) {
      return /iPad|Transformer|ME173X|KOOF|Nook|IMM76D|Nexus 10|Nexus 7|Tablet/i.test(e) || /HP Slate|PG09410|PG41200|Mediapad|Kindle|Tab|Xoom|TegraNote|SCH-I800/i.test(e) ? "Tablet" : /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(e) ? "Mobile" : "Desktop";
    }
  }
  const se = e => {
      switch (e.type) {
        case "categorized":
          return e.items.reduce((e, t) => e + t.typeaheadResults.length, 0);
        case "uncategorized":
          return e.items.length;
      }
    },
    ne = (e, t) => {
      switch (e.type) {
        case "categorized":
          return Object.assign(Object.assign({}, e), {
            items: e.items.map(e => Object.assign(Object.assign({}, e), {
              typeaheadResults: e.typeaheadResults.filter(e => !t.includes(e.value))
            }))
          });
        case "uncategorized":
          return Object.assign(Object.assign({}, e), {
            items: e.items.filter(e => !t.includes(e.value))
          });
      }
    },
    le = (e, t) => {
      switch (e.type) {
        case "categorized":
          return e.items.reduce((e, t) => (e.push(...t.typeaheadResults), e), [])[t];
        case "uncategorized":
          return e.items[t];
      }
    },
    re = S.p + "./styles/egds-search-experience-typeahead-custom.css",
    oe = w.classNames.bind(re);
  class ce extends T.Component {
    render() {
      const _a = this.props,
        {
          className: e,
          placeholder: t,
          required: a
        } = _a,
        i = __rest(_a, ["className", "placeholder", "required"]),
        s = oe("uitk-typeahead-input", e);
      return T.createElement(K.UitkInput, Object.assign(Object.assign({}, i), {
        autoCapitalize: "off",
        autoComplete: "off",
        autoCorrect: "off",
        className: s,
        type: "text",
        spellCheck: !1,
        placeholder: t,
        required: a
      }));
    }
  }
  ce.displayName = "UitkTypeaheadInput";
  const de = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkActionList: () => m.UitkActionList,
      UitkActionListItem: () => m.UitkActionListItem,
      UitkActionListItemLink: () => m.UitkActionListItemLink
    }),
    ue = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkText: () => p.UitkText
    }),
    he = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkSpacing: () => g.UitkSpacing
    }),
    me = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      UitkLineSkeleton: () => y.UitkLineSkeleton
    }),
    pe = "data:image/png;base64,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",
    ge = w.classNames.bind(re),
    ye = e => {
      const {
        results: t
      } = e;
      let a;
      const i = e => {
          var _a;
          return e ? (_a = e.data) === null || _a === void 0 ? void 0 : _a.category : "";
        },
        s = e => e.find(e => e.data && e.data.category),
        n = e => e.some(e => {
          const t = "category";
          return e.data && e.data[t] && e.data[t] === a;
        });
      return (e => {
        switch (e.type) {
          case "categorized":
            return a = (e => {
              const t = e.find(e => s(e.typeaheadResults));
              return void 0 !== t && t.typeaheadResults ? i(t.typeaheadResults[0]) : "";
            })(e.items), (e => e.some(e => n(e.typeaheadResults)))(e.items);
          case "uncategorized":
            return a = (e => i(s(e)))(e.items), (e => n(e))(e.items);
        }
      })(t) && a === Q ? T.createElement("div", {
        className: ge("uitk-typeahead-google-logo")
      }, T.createElement("img", {
        src: pe,
        alt: "Powered by Google Logo"
      })) : null;
    },
    fe = T.default.createContext({
      impressionWrapper: void 0
    }),
    Re = ({
      isPopularFilter: e,
      isUserHistory: t
    }) => e ? "PopularFilter" : t ? "UserHistory" : "ResultItem",
    ve = w.classNames.bind(re),
    Te = ({
      children: e
    }) => T.createElement(T.Fragment, null, e),
    Ee = e => {
      const {
          data: t,
          onResultItemSelect: a,
          value: i,
          className: s,
          subtext: n,
          activeSuggestion: l,
          name: r,
          contentRef: o,
          icon: c,
          historyDetail: d,
          sanitized: u,
          stid: h,
          index: m,
          handleRemoveRecentSearch: p,
          allowToRemoveRecentSearches: g
        } = e,
        {
          formatText: y
        } = (0, V.useLocalization)(),
        f = n ? `${r} ${n}`.replace(/(<([^>]+)>)/gi, "") : r === null || r === void 0 ? void 0 : r.replace(/(<([^>]+)>)/gi, ""),
        R = `full-search-detail-${d || !1}`,
        v = "USERHISTORY" === (t === null || t === void 0 ? void 0 : t.category),
        E = !!(t === null || t === void 0 ? void 0 : t.popularFilter),
        S = y("typeahead.custom.delete.recent.search.button.label.a11y", i),
        b = y("typeahead.custom.delete.recent.search.button.announce.a11y", i),
        k = ve(s, n ? "uitk-typeahead-result-item has-subtext" : "uitk-typeahead-result-item", !0 === l && "uitk-typeahead-result-item-hover");
      if (!0 === l) {
        const e = r.replace(/(<([^>]+)>)/gi, "");
        (0, w.liveAnnounce)(`${e}`, void 0, void 0, o);
      }
      const I = u ? T.createElement("span", null, r) : T.createElement("div", {
          className: ve("typeahead-custom-truncate")
        }, T.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: r
          }
        })),
        A = !u && n && ((t === null || t === void 0 ? void 0 : t.popularFilter) ? T.createElement("div", {
          className: ve("typeahead-custom-truncate")
        }, T.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: n
          }
        })) : T.createElement("div", {
          "data-stid": R,
          className: ve("is-subText", "typeahead-custom-truncate"),
          dangerouslySetInnerHTML: {
            __html: n
          }
        })),
        {
          impressionWrapper: C
        } = T.useContext(fe),
        U = C !== null && C !== void 0 ? C : Te,
        N = Re({
          isPopularFilter: E,
          isUserHistory: v
        }),
        L = `${N}.Presented.${E ? `${i} - ${n.replace(/(<([^>]+)>)/gi, "")}` : i}`,
        D = N;
      return T.createElement(U, {
        linkNameSuffix: D,
        referrerIdSuffix: L
      }, T.createElement(de.UitkActionListItem, {
        spacing: "relaxed",
        className: k,
        "data-stid": h && `${h}-result-item`,
        "data-index": m
      }, T.createElement("div", {
        className: ve("uitk-typeahead-result-item-container")
      }, T.createElement(H.UitkButton, {
        "data-stid": h && `${h}-result-item-button`,
        onClick: () => {
          a(i, t);
        },
        className: ve(n && "has-subtext", `${h}-result-item-button`, "result-item-button"),
        "aria-label": f,
        type: "button",
        isFullWidth: !0
      }), T.createElement(W.UitkLayoutFlex, null, c && T.createElement(W.UitkLayoutFlexItem, {
        alignSelf: "center"
      }, T.createElement(x.UitkIcon, {
        name: c,
        size: x.UitkIconSize.MEDIUM
      })), T.createElement(W.UitkLayoutFlexItem, null, T.createElement("div", {
        className: ve("uitk-typeahead-button-label", "typeahead-custom-truncate")
      }, I, A)), v && g && !E && T.createElement(W.UitkLayoutFlexItem, {
        alignSelf: "center",
        grow: 1
      }, T.createElement(W.UitkLayoutFlex, {
        justifyContent: "end"
      }, T.createElement(H.UitkTertiaryButton, {
        onClick: () => {
          p(t === null || t === void 0 ? void 0 : t.regionId), (0, w.liveAnnounce)(1 === b.length ? `${r} was deleted from recent searches` : b);
        },
        "aria-label": 0 === S.length ? `Delete ${i} from recent searches` : S
      }, T.createElement(x.UitkIcon, {
        name: "close",
        size: x.UitkIconSize.SMALL
      }))))))));
    },
    Se = w.classNames.bind(re),
    be = e => {
      const {
          headingText: t,
          hideHeading: a = !1,
          typeaheadLabel: i,
          stid: s = "",
          values: n,
          onItemRemove: l,
          onClear: r,
          clearAllText: o,
          className: c
        } = e,
        d = (0, V.useLocalization)(),
        u = o !== null && o !== void 0 ? o : d.formatText("typeahead.mulselect.clearAll"),
        h = t !== null && t !== void 0 ? t : d.formatText("typeahead.multiselect.selectedItemHeading");
      return T.createElement("div", {
        className: Se("uitk-typeahead-selections", c)
      }, !a && h && (n === null || n === void 0 ? void 0 : n.length) > 0 && T.createElement("div", {
        className: Se("uitk-typeahead-result-title-label", "typeahead-custom-truncate")
      }, h), T.createElement("div", {
        className: Se("uitk-typeahead-pills"),
        "data-stid": s
      }, n === null || n === void 0 ? void 0 : n.map((e, t) => T.createElement(I.UitkRemovablePill, {
        onClick: () => ((e, t) => {
          (0, w.liveAnnounce)(d.formatText("typeahead.removeSelection", e)), l === null || l === void 0 ? void 0 : l(t);
        })(e, t),
        id: `${s}-pill-${t}`,
        key: `${s}-pill-${t}`,
        className: Se("uitk-spacing-margin-block-one")
      }, e)), (n === null || n === void 0 ? void 0 : n.length) && T.createElement(H.UitkTertiaryButton, {
        onClick: () => {
          (0, w.liveAnnounce)(d.formatText("typeahead.clearAllSelections", i)), r === null || r === void 0 ? void 0 : r();
        },
        size: H.UitkButtonSize.SMALL
      }, u)));
    },
    ke = w.classNames.bind(re),
    Ie = e => {
      const t = e && e.data && e.data.type === te.CURRENT_LOCATION;
      return ke({
        "is-nested-child": e.data && (e.isChild || e.data.popularFilter),
        "uitk-typeahead-current-location": t && e.data.enabled,
        disabled: t && !e.data.enabled
      });
    };
  function we(e) {
    const {
        activeSuggestion: t,
        allowExactMatch: a,
        listTitle: i,
        typeaheadLabel: s,
        onResultItemSelect: n,
        results: l,
        searchTerm: r,
        stid: o,
        emptyResultPlaceholder: c,
        isMulti: d,
        onClearAll: u,
        onItemRemove: h,
        clearAllText: m,
        selectedItemHeading: p,
        value: g,
        domRef: y,
        contentRef: f,
        historyDetail: R,
        allowToRemoveRecentSearches: v,
        handleRemoveRecentSearch: E
      } = e,
      S = (0, V.useLocalization)(),
      b = d ? ne(l, g) : l,
      k = se(b),
      I = d ? "uitk-typeahead-multi-selection-results" : "uitk-typeahead-results",
      w = () => d && g.length > 0 ? T.createElement(be, {
        typeaheadLabel: s,
        values: g,
        stid: o,
        clearAllText: m,
        onClear: u,
        onItemRemove: h,
        headingText: p,
        className: ke("uitk-typeahead-results-selections")
      }) : null;
    if (!l || 0 === l.items.length) return c ? T.createElement(he.UitkSpacing, {
      padding: {
        blockstart: "three"
      }
    }, T.createElement("div", null, w(), T.createElement(W.UitkLayoutFlex, {
      justifyContent: "center",
      alignContent: "center",
      className: ke("uitk-typeahead-empty-state")
    }, T.createElement(ue.UitkText, {
      align: "center"
    }, T.createElement(he.UitkSpacing, {
      margin: {
        blockstart: "six"
      }
    }, T.createElement(x.UitkIcon, {
      name: "search",
      size: x.UitkIconSize.XLARGE
    })), T.createElement(he.UitkSpacing, {
      margin: {
        blockend: "three"
      }
    }, T.createElement(ue.UitkText, {
      size: 300
    }, c)))))) : T.createElement(he.UitkSpacing, {
      padding: {
        blockstart: "three"
      }
    }, T.createElement("div", null, w()));
    function A(e, t) {
      n(e, t, b);
    }
    const C = e => {
        var _a;
        return (_a = e[0]) === null || _a === void 0 ? void 0 : _a.disabled;
      },
      U = e => {
        var _a, _b;
        return (_b = (_a = e[0]) === null || _a === void 0 ? void 0 : _a.typeaheadResults[0]) === null || _b === void 0 ? void 0 : _b.disabled;
      },
      N = () => T.createElement("div", {
        className: ke("uitk-typeahead-results-skeleton-container")
      }, T.createElement(me.UitkLineSkeleton, {
        className: ke("uitk-typeahead-results-skeleton", "uitk-typeahead-results-skeleton-first")
      }), T.createElement(me.UitkLineSkeleton, {
        className: ke("uitk-typeahead-results-skeleton", "uitk-typeahead-results-skeleton-second")
      }), T.createElement(me.UitkLineSkeleton, {
        className: ke("uitk-typeahead-results-skeleton")
      }));
    return T.createElement(he.UitkSpacing, {
      padding: {
        blockstart: "three"
      }
    }, T.createElement("div", {
      className: ke(I),
      ref: y
    }, w(), T.createElement(de.UitkActionList, {
      className: ke("no-bullet"),
      "data-stid": o && `${o}-results`
    }, (e => {
      switch (e.type) {
        case "categorized":
          return U(e.items) ? N() : (s = e.items) && s.map(e => T.createElement(T.Fragment, {
            key: e.heading
          }, e.heading && T.createElement(de.UitkActionListItem, {
            spacing: "relaxed",
            className: ke("uitk-typeahead-result-title")
          }, T.createElement("div", {
            className: ke("uitk-typeahead-result-title-label", "typeahead-custom-truncate")
          }, e.heading)), e.typeaheadResults && e.typeaheadResults.map((e, a) => {
            var _a;
            return T.createElement(Ee, {
              className: Ie(e),
              data: e.data,
              key: a,
              index: a,
              icon: e.icon,
              name: e.name,
              handleRemoveRecentSearch: E,
              onResultItemSelect: A,
              stid: o,
              value: e.value,
              subtext: e.subtext,
              allowToRemoveRecentSearches: v,
              activeSuggestion: -1 !== t && t === ((_a = e.data) === null || _a === void 0 ? void 0 : _a.index),
              historyDetail: R
            });
          })));
        case "uncategorized":
          return C(e.items) ? N() : (a = e.items) && a.map((e, a) => T.createElement(T.Fragment, {
            key: a
          }, i && T.createElement(de.UitkActionListItem, {
            spacing: "relaxed",
            className: ke("uitk-typeahead-result-title")
          }, T.createElement("div", {
            className: ke("uitk-typeahead-result-title-label", "typeahead-custom-truncate")
          }, e.title)), T.createElement(Ee, {
            className: Ie(e),
            data: e.data,
            key: a,
            index: a,
            icon: e.icon,
            name: e.name,
            allowToRemoveRecentSearches: v,
            onResultItemSelect: A,
            handleRemoveRecentSearch: E,
            stid: o,
            value: e.value,
            subtext: e.subtext,
            activeSuggestion: -1 !== t && t === a,
            contentRef: f,
            historyDetail: R
          })));
      }
      var a, s;
    })(b), a && r && !(e => {
      switch (e.type) {
        case "categorized":
          return U(e.items);
        case "uncategorized":
          return C(e.items);
      }
    })(b) && T.createElement(Ee, {
      icon: "search",
      name: S.formatText("typeahead.searchFor", [r]),
      onResultItemSelect: A,
      handleRemoveRecentSearch: E,
      index: k,
      stid: o,
      value: r,
      allowToRemoveRecentSearches: v,
      sanitized: !0,
      activeSuggestion: !(-1 === t || t !== k),
      historyDetail: R
    })), T.createElement(ye, {
      results: b
    })));
  }
  const xe = (e => {
    var t = {};
    return S.d(t, e), t;
  })({
    __assign: () => f.__assign,
    __extends: () => f.__extends,
    __rest: () => f.__rest,
    __spreadArray: () => f.__spreadArray
  });
  var Ae = S(197),
    Ce = S.n(Ae),
    Ue = w.classNames.bind(Ce()),
    Ne = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return (0, xe.__extends)(t, e), t.prototype.render = function () {
        var e = this.props,
          t = e.id,
          a = e.label,
          i = e.className,
          s = Ue("uitk-field-label", i);
        return T.createElement("label", {
          htmlFor: t,
          className: s
        }, a);
      }, t.displayName = "UitkFieldLabel", t;
    }(T.Component),
    Le = w.classNames.bind(Ce()),
    De = function (e) {
      var t = e.className,
        a = e.message,
        i = e.id,
        s = e.type,
        n = Le("uitk-field-message", "uitk-field-message-".concat(s), "uitk-".concat(s, "-message"), t);
      return T.createElement("div", {
        className: n,
        id: "".concat(i, "-").concat(s)
      }, a);
    },
    Pe = w.classNames.bind(Ce()),
    ze = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return (0, xe.__extends)(t, e), t.prototype.render = function () {
        var e = this.props,
          t = e.className,
          a = e.labelClassName,
          i = e.label,
          s = e.instruction,
          n = e.invalid,
          l = e.hasFloatedLabel,
          r = e.icon,
          o = e.hasAutofill,
          c = e.hasBorder,
          d = e.hasVisibleLabel,
          u = e.children,
          h = e.required,
          m = this.props,
          p = m.id,
          g = m.disabled,
          y = m.placeholder,
          f = m.readOnly,
          R = Pe("uitk-field", t, {
            "has-autofill": o,
            "has-floatedLabel-label": l,
            "has-icon": r,
            "has-no-border": !c,
            "has-no-visible-label": !d,
            "has-placeholder": !!(null == y ? void 0 : y.trim()),
            "has-textarea": T.Children.toArray(u).some(function (e) {
              return !("textarea" !== (null == e ? void 0 : e.type));
            }),
            "is-disabled": g,
            "is-invalid": n,
            "is-readonly": f,
            "is-required": h
          }),
          v = [];
        a && v.push(a), d && y || v.push("is-visually-hidden");
        var E = {
            className: v.join(" "),
            id: p,
            label: i,
            placeholder: y
          },
          S = function (e, t) {
            var a;
            return e && ("string" == typeof e && (a = T.createElement(De, {
              id: p,
              message: e,
              type: t
            })), "object" == typeof e && (a = T.createElement("div", {
              className: Pe("uitk-field-messages")
            }, e.primary && T.createElement(De, {
              className: Pe("uitk-field-message-primary"),
              id: p,
              message: e.primary,
              type: t
            }), e.secondary && T.createElement(De, {
              className: Pe("uitk-field-message-secondary"),
              id: p,
              message: e.secondary,
              type: t
            })))), a;
          };
        return T.createElement(w.UitkContextWrapper, null, function (e, t) {
          return T.createElement(T.Fragment, null, T.createElement("div", {
            className: R
          }, T.createElement(Ne, (0, xe.__assign)({}, E)), u, !y && d && T.createElement("div", {
            className: Pe("uitk-field-label"),
            "aria-hidden": "true"
          }, i, h && (null == t ? void 0 : t.hasRequiredFieldIndicator) && T.createElement("span", {
            className: "uitk-field-required-asterisk",
            "aria-hidden": "true"
          }, " ", "*")), r && T.createElement(x.UitkIcon, {
            className: Pe("uitk-field-icon"),
            name: r
          })), n && S(n, "error"), s && S(s, "instruction"));
        });
      }, t.displayName = "UitkField", t.defaultProps = {
        hasBorder: !0,
        hasFloatedLabel: !0,
        hasVisibleLabel: !0
      }, t;
    }(T.Component);
  const Oe = S.p + "./styles/egds-search-experience-typeahead-custom-text-input.css",
    Me = w.classNames.bind(Oe),
    Fe = e => {
      const {
          hasClearButton: t = !1,
          required: a = !1,
          value: i = "",
          domRef: s = T.createRef(),
          handleClear: n,
          onChange: l,
          id: r,
          name: o,
          children: c,
          label: d,
          hasBorder: u,
          hasFloatedLabel: h,
          hasVisibleLabel: m = !1,
          icon: p,
          instruction: g,
          invalid: y,
          placeholder: f,
          disabled: R,
          readOnly: v,
          predictiveText: E
        } = e,
        S = __rest(e, ["hasClearButton", "required", "value", "domRef", "handleClear", "onChange", "id", "name", "children", "label", "hasBorder", "hasFloatedLabel", "hasVisibleLabel", "icon", "instruction", "invalid", "placeholder", "disabled", "readOnly", "predictiveText"]),
        b = (0, V.useLocalization)(),
        [k, I] = T.useState(E);
      T.useEffect(() => {
        I(E);
      }, [E]);
      const w = t && !!i,
        A = {
          labelClassName: Me(w && "has-typeahead-custom-text-input-cta"),
          disabled: R,
          hasBorder: u,
          hasFloatedLabel: h,
          hasVisibleLabel: m,
          icon: p,
          id: r,
          instruction: g,
          invalid: y,
          label: d,
          placeholder: f,
          readOnly: v,
          required: a
        },
        C = Me("uitk-field-input", w && "has-typeahead-custom-text-input-cta", "typeahead-custom-text-input"),
        U = (() => {
          var _a;
          if (T.isValidElement(d)) {
            const e = d.props;
            return (_a = e === null || e === void 0 ? void 0 : e.children) !== null && _a !== void 0 ? _a : "";
          }
          return d;
        })(),
        N = b.formatText("clear"),
        L = w ? [N, U].join(" ") : "";
      return T.createElement(ze, Object.assign({}, A), T.createElement("input", Object.assign(Object.assign({}, S), {
        value: i,
        onChange: l,
        className: C,
        "aria-describedby": y ? `${r}-error` : void 0,
        placeholder: f,
        ref: s,
        id: r,
        "aria-required": a,
        "aria-invalid": !!y,
        type: "text"
      })), c, k && T.createElement("input", Object.assign(Object.assign({}, S), {
        className: Me("predictive-text", "uitk-field-input", w && "has-typeahead-custom-text-input-cta", "typeahead-custom-text-input"),
        value: k,
        readOnly: !0
      })), w && T.createElement("button", {
        className: Me("uitk-clear-button", "typeahead-custom-text-input-cta"),
        onClick: () => {
          var _a;
          l === null || l === void 0 ? void 0 : l({
            target: {
              value: "",
              name: o
            }
          }), (_a = s === null || s === void 0 ? void 0 : s.current) === null || _a === void 0 ? void 0 : _a.focus(), n === null || n === void 0 ? void 0 : n(), I("");
        },
        type: "button"
      }, T.createElement(x.UitkIcon, {
        name: "cancel",
        size: x.UitkIconSize.SMALL,
        title: L,
        id: `${r}-clear-input-button`
      })));
    };
  Fe.displayName = "TypeaheadCustomTextInput";
  const _e = (e => {
      var t = {};
      return S.d(t, e), t;
    })({
      normalizeText: () => R.normalizeText
    }),
    $e = (e, t) => {
      const a = e.length;
      if (0 === a || a > 22) return "";
      const i = (0, _e.normalizeText)(t),
        s = (0, _e.normalizeText)(e);
      return i.substring(0, a) === s ? e + t.substring(a) : "";
    },
    Ve = w.classNames.bind(re);
  var Be;
  !function (e) {
    e.UP = "UP", e.DOWN = "DOWN";
  }(Be || (Be = {}));
  class Ke extends T.Component {
    constructor(e) {
      super(e), this.toolbarInputRef = T.createRef(), this.iphoneSafariUARegex = /iphone.*safari|safari.*iphone/gi, this.uid = Math.random().toString(36).substring(7), this.typeaheadDialogLiveAnnounceId = `uitk-typeahead-dialog-live-announce-${this.uid}`, this.typingTimeout = 0, this.newAttr = -1, this._isMounted = !1, this.state = {
        activeSuggestion: -1,
        categorizedResults: [],
        showPredictiveText: !0,
        data: {},
        results: [],
        searchTerm: e.term,
        showResults: !0,
        predictiveTextValue: "",
        startSearchTerm: e.startSearchTerm,
        isCurrentLocation: !1
      }, this.announceResults = this.announceResults.bind(this), this.focusInput = this.focusInput.bind(this), this.handleChange = this.handleChange.bind(this), this.handleKeyPress = this.handleKeyPress.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleKeyUp = this.handleKeyUp.bind(this), this.handleAnnounceResults = this.handleAnnounceResults.bind(this), this.handleResultItemSelect = this.handleResultItemSelect.bind(this), this.onDismiss = this.onDismiss.bind(this), this.openDialog = this.openDialog.bind(this), this.updateResults = this.updateResults.bind(this), this.updateResultsDebounced = e.debounceRate && e.debounceRate > 0 ? (0, P.debounce)(e.debounceRate, this.updateResults) : this.updateResults, this.updateInput = this.updateInput.bind(this), this.selectInput = this.selectInput.bind(this), this.resetActiveSuggestion = this.resetActiveSuggestion.bind(this), this.removeDialogLiveAnnounce = this.removeDialogLiveAnnounce.bind(this), this.handleRemoveRecentSearch = this.handleRemoveRecentSearch.bind(this), this.contentRef = T.createRef();
    }
    componentDidMount() {
      this._isMounted = !0;
    }
    componentDidUpdate(e, t) {
      const {
        term: a,
        dialog: i
      } = this.props;
      a !== e.term && this.setState({
        searchTerm: a
      });
      const {
        searchTerm: s,
        showResults: n
      } = this.state;
      t.searchTerm !== s && i && n && (this.setState({
        results: Ke.placeholder
      }), this.updateResultsDebounced(s));
    }
    componentWillUnmount() {
      this._isMounted = !1;
    }
    handleChange(e) {
      const {
          handleType: t
        } = this.props,
        a = e.target.value;
      this.setState({
        searchTerm: a,
        showResults: !0,
        isCurrentLocation: !1,
        predictiveTextValue: ""
      }, this.focusInput), "" === a && this.resetActiveSuggestion(), t(a);
    }
    handleResultItemSelect(e, t, a) {
      var _a;
      const {
          isMulti: i,
          adapter: s,
          l10n: n,
          label: l,
          onResultItemSelect: r
        } = this.props,
        {
          searchTerm: o
        } = this.state;
      return (_a = s.onItemSelection) === null || _a === void 0 ? void 0 : _a.call(s, t).then(s => {
        i ? this.setState({
          activeSuggestion: -1
        }) : this.setState({
          activeSuggestion: -1,
          searchTerm: e,
          showResults: !1,
          isCurrentLocation: (t === null || t === void 0 ? void 0 : t.type) === te.CURRENT_LOCATION
        }), r(e, s, t);
        const c = a ? se(a) - 1 : 0;
        i && (0, w.liveAnnounce)(`${n.formatText("typeahead.announceResults.itemSelected", e)}\n             ${n.formatText("typeahead.announceResults.showingResults", l, c, o)}`, void 0, void 0, this.contentRef, this.typeaheadDialogLiveAnnounceId), i || (setTimeout(() => {
          (0, w.liveAnnounce)(`${n.formatText("typeahead.announceResults.itemSelected", e)}\n             ${n.formatText("typeahead.announceResults.menuClosed")}`);
        }, 100), this.onDismiss());
      }).catch(() => {
        this.updateResults(e, !0, "" !== e), this.onDismiss();
      });
    }
    handleRemoveRecentSearch(e) {
      this.setState(t => Object.assign(Object.assign({}, t), {
        results: this.filterTypeaheadResult(e, t.results),
        categorizedResults: t.categorizedResults.map(t => Object.assign(Object.assign({}, t), {
          typeaheadResults: this.filterTypeaheadResult(e, t.typeaheadResults)
        })).filter(e => e.typeaheadResults.length >= 1)
      })), this.removeRecentSearch(e);
    }
    handleAnnounceResults(e) {
      this.typingTimeout && clearTimeout(this.typingTimeout), e.length > 0 && (this.typingTimeout = setTimeout(() => {
        this.announceResults(e);
      }, 1e3));
    }
    handleKeyPress(e) {
      const {
          value: t
        } = this.props,
        a = ne(this.getResultsToShow(), Array.isArray(t) ? t : []),
        {
          activeSuggestion: i,
          searchTerm: s,
          predictiveTextValue: n
        } = this.state;
      if ("Enter" !== e.key && 38 !== e.keyCode && 40 !== e.keyCode || e.preventDefault(), "Enter" === e.key) {
        const e = n.length > 0 && -1 === i ? le(a, 0) : le(a, i);
        e ? this.handleResultItemSelect(e.value, e.data, a) : this.handleResultItemSelect(s, void 0, a);
      }
    }
    handleActiveSuggestion(e) {
      const {
          activeSuggestion: t,
          results: a,
          searchTerm: i
        } = this.state,
        {
          allowExactMatch: s
        } = this.props,
        n = s && i ? 1 : 0,
        l = a.length + n;
      let r = 0;
      e === Be.UP ? r = -1 === t ? l : l - 1 : e === Be.DOWN && (r = l + 1);
      const o = (t + r) % l,
        c = (this.newAttr + r) % l;
      this.setState({
        activeSuggestion: this.newAttr > -1 ? c : o
      }), this.newAttr = -1;
    }
    handleUpArrowKey(e) {
      38 === e.keyCode && this.handleActiveSuggestion(Be.UP);
    }
    handleDownArrowKey(e) {
      40 === e.keyCode && this.handleActiveSuggestion(Be.DOWN);
    }
    handleTabKey(e) {
      if (9 === e.keyCode || e.shiftKey && 9 === e.keyCode) {
        const t = e.target.parentElement.getAttribute("data-index");
        this.newAttr = t ? Number(t) : -1;
      }
    }
    handleDelete(e) {
      8 === e.keyCode ? this.resetActiveSuggestion() : this.setState({
        showPredictiveText: !0
      });
    }
    handleEscKey(e) {
      27 === e.keyCode && this.onDismiss();
    }
    handleKeyDown(e) {
      this.handleDownArrowKey(e), this.handleUpArrowKey(e), this.handleEscKey(e), this.handleDelete(e);
    }
    handleKeyUp(e) {
      this.handleTabKey(e);
    }
    onDismiss() {
      const {
        onDismiss: e,
        isMulti: t,
        l10n: a
      } = this.props;
      this.contentRef.current.scrollTop = 0, e === null || e === void 0 ? void 0 : e(), this.resetActiveSuggestion(), this.setState({
        startSearchTerm: ""
      }), t && setTimeout(() => {
        (0, w.liveAnnounce)(a.formatText("typeahead.announceResults.menuClosed"));
      }, 100), this.removeDialogLiveAnnounce();
    }
    getResultsToShow() {
      const {
          categorize: e
        } = this.props,
        {
          categorizedResults: t,
          results: a
        } = this.state;
      return e || t && t.length ? {
        items: t,
        type: "categorized"
      } : {
        items: a,
        type: "uncategorized"
      };
    }
    filterTypeaheadResult(e, t) {
      return t.filter(t => {
        const a = t.data;
        return (a === null || a === void 0 ? void 0 : a.regionId) === e && "USERHISTORY" === (a === null || a === void 0 ? void 0 : a.category) ? null : t;
      });
    }
    removeRecentSearch(e) {
      return __awaiter(this, void 0, void 0, function* () {
        const {
          adapter: t
        } = this.props;
        yield t.fetchDeleteRecentSearch(e);
      });
    }
    removeDialogLiveAnnounce() {
      var _a;
      const e = document.getElementById(this.typeaheadDialogLiveAnnounceId);
      e && ((_a = e.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(e));
    }
    resetActiveSuggestion() {
      this.setState({
        activeSuggestion: -1,
        predictiveTextValue: "",
        showPredictiveText: !1
      });
    }
    updateInput(e, t) {
      this.setState({
        searchTerm: e
      }, () => {
        this.updateResults(e, !1, !!t), setTimeout(() => {
          this.selectInput();
        });
      });
    }
    scrollTop() {
      navigator.userAgent.match(this.iphoneSafariUARegex) && document.getElementsByTagName("html")[0].scrollTop > 0 && document.getElementsByTagName("html")[0].scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
    openDialog() {
      const {
          searchTerm: e
        } = this.state,
        {
          startSearchTerm: t
        } = this.props;
      this.updateInput(e || t || "", "" !== e), this.focusInput(), this.scrollTop();
    }
    selectInput() {
      var _a, _b;
      const {
        toolbarInputRef: e
      } = this;
      (_b = (_a = e === null || e === void 0 ? void 0 : e.current) === null || _a === void 0 ? void 0 : _a.select) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    focusInput() {
      var _a, _b;
      const {
        toolbarInputRef: e
      } = this;
      (_b = (_a = e === null || e === void 0 ? void 0 : e.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    announceResults(e) {
      const {
          searchTerm: t
        } = this.state,
        {
          l10n: a
        } = this.props,
        i = t && t.split("");
      if (i) {
        const t = `'${i.join("' , '")} '`;
        e && (0, w.liveAnnounce)(a.formatText("typeahead.announceResults.resultsAvailable", t, e.length), void 0, void 0, this.contentRef, this.typeaheadDialogLiveAnnounceId);
      }
    }
    isCategorizedResult(e) {
      return "object" == typeof e && "heading" in e;
    }
    updateResults(e, t, a) {
      return __awaiter(this, void 0, void 0, function* () {
        const {
            adapter: i,
            categorize: s,
            resultsRequestDurationTimeCallback: n,
            predictiveText: l,
            onRecommendationImpression: r
          } = this.props,
          {
            isCurrentLocation: o,
            showPredictiveText: c
          } = this.state,
          d = "" === e || o ? "" : e;
        let u, h;
        this.lastSearchTerm = d;
        const m = performance.now();
        if ("" !== d && !0 === t) {
          const [e, t] = s ? yield Promise.all([i.fetchResultsCategorized(d), i.fetchRecentSearchResultsCategorized()]) : yield Promise.all([i.fetchResults(d), i.fetchRecentSearchResults()]);
          t && t.length > 0 ? s || this.isCategorizedResult(t[0]) ? h = t : u = t : s ? h = e : u = e;
        } else if (s) h = yield i.fetchResultsCategorized(d);else if ("" !== d && a) {
          const e = yield i.fetchAlternativeResults(d);
          e && e.length && this.isCategorizedResult(e[0]) ? h = e : u = e;
        } else {
          const e = yield i.fetchResults(d);
          e && e.length && this.isCategorizedResult(e[0]) ? h = e : u = e;
        }
        if (n === null || n === void 0 ? void 0 : n(performance.now() - m, "" !== d.trim()), this.lastSearchTerm === d) if (u && u.length && this._isMounted) {
          if (r === null || r === void 0 ? void 0 : r(t || a ? "" : d), this.setState({
            results: u,
            categorizedResults: []
          }, () => {
            this.handleAnnounceResults(u);
          }), l && c) {
            this.resetActiveSuggestion();
            const e = $e(d, u[0].title);
            e.length > 0 && this.setState({
              predictiveTextValue: e
            });
          }
        } else if (h && h.length) {
          r === null || r === void 0 ? void 0 : r(t || a ? "" : d);
          const e = h.reduce((e, t) => (e.push(...t.typeaheadResults), e), []);
          this.setState({
            categorizedResults: h,
            results: e
          }, () => {
            this.handleAnnounceResults(h);
          });
        } else this._isMounted && this.setState({
          results: [],
          categorizedResults: []
        });
      });
    }
    render() {
      const {
          allowExactMatch: e,
          dialog: t,
          id: a,
          listTitle: i,
          stid: s,
          placeholder: n,
          label: l,
          handleClear: r,
          emptyResultPlaceholder: o,
          isMulti: c,
          dismissButtonText: d,
          clearAllText: u,
          onClearAll: h,
          onItemRemove: m,
          selectedItemHeading: p,
          value: g,
          typeaheadInputRef: y,
          required: f,
          allowToRemoveRecentSearches: R,
          historyDetail: v,
          predictiveText: E
        } = this.props,
        {
          activeSuggestion: S,
          searchTerm: b,
          predictiveTextValue: k
        } = this.state,
        I = this.getResultsToShow();
      return T.createElement(Y.UitkSheetTransition, {
        isVisible: t,
        openCallback: this.openDialog
      }, T.createElement(Y.UitkSheet, {
        className: Ve("uitk-typeahead-dialog", "uitk-typeahead-dialog-centered"),
        isVisible: t,
        type: "centered",
        triggerRef: y
      }, T.createElement(W.UitkLayoutFlex, {
        direction: "column",
        blockSize: "full_size"
      }, T.createElement(W.UitkLayoutFlexItem, null, T.createElement(q.UitkToolbar, {
        className: Ve("uitk-typeahead-input-wrapper"),
        navigationContent: {
          navIconLabel: "Close the dialog",
          onClick: this.onDismiss,
          navButtonId: `${a}-close`
        }
      }, T.createElement("div", {
        id: "search-location-input-field"
      }, E ? T.createElement(Fe, {
        autoComplete: "off",
        "data-stid": s && `${s}-dialog-input`,
        domRef: this.toolbarInputRef,
        hasClearButton: b.length > 0,
        hasFloatedLabel: !1,
        hasVisibleLabel: !1,
        id: s,
        label: l,
        onChange: this.handleChange,
        placeholder: n,
        value: b,
        onKeyDown: this.handleKeyDown,
        onKeyPress: this.handleKeyPress,
        onKeyUp: this.handleKeyUp,
        handleClear: r,
        required: f,
        predictiveText: k
      }) : T.createElement(ce, {
        className: Ve("uitk-typeahead-input-v2"),
        "data-stid": s && `${s}-dialog-input`,
        domRef: this.toolbarInputRef,
        hasClearButton: b.length > 0,
        hasFloatedLabel: !1,
        hasVisibleLabel: !1,
        id: s,
        label: l,
        onChange: this.handleChange,
        onKeyPress: this.handleKeyPress,
        placeholder: n,
        value: b,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        handleClear: r,
        required: f
      })))), T.createElement(W.UitkLayoutFlexItem, null, T.createElement(Y.UitkSheetContent, {
        className: Ve("uitk-typeahead-dialog-content"),
        contentDomRef: this.contentRef,
        padded: !1
      }, T.createElement(W.UitkLayoutFlex, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
      }, T.createElement(W.UitkLayoutFlexItem, null, T.createElement(we, {
        allowExactMatch: e,
        typeaheadLabel: l,
        onResultItemSelect: this.handleResultItemSelect,
        results: I,
        searchTerm: b,
        stid: s,
        listTitle: i,
        activeSuggestion: S,
        emptyResultPlaceholder: o,
        isMulti: c,
        dismissButtonText: d,
        selectedItemHeading: p,
        clearAllText: u,
        onClearAll: h,
        onItemRemove: m,
        value: g,
        contentRef: this.contentRef,
        historyDetail: v,
        allowToRemoveRecentSearches: R,
        handleRemoveRecentSearch: this.handleRemoveRecentSearch
      })), this.props.isMulti ? T.createElement(W.UitkLayoutFlexItem, null, T.createElement(G.UitkScrim, {
        type: G.UitkScrimType.BUTTON
      }, T.createElement(H.UitkFloatingFullWidthButton, {
        disabled: 0 === (g === null || g === void 0 ? void 0 : g.length),
        onClick: this.onDismiss,
        isFullWidth: !0
      }, d))) : null))))));
    }
  }
  Ke.placeholder = [{
    disabled: !0,
    icon: "brightness_1",
    name: " ",
    value: " ",
    title: " "
  }];
  const He = e => {
      const t = (0, V.useLocalization)();
      return T.createElement(Ke, Object.assign({
        l10n: t
      }, e));
    },
    We = w.classNames.bind(re),
    Ge = e => "" === e || Array.isArray(e) && 0 === e.length;
  var Ye;
  !function (e) {
    e.UP = "UP", e.DOWN = "DOWN";
  }(Ye || (Ye = {}));
  class qe extends T.Component {
    constructor(e) {
      super(e), this.toolbarInputRef = T.createRef(), this.keyPressed = !1, this.newAttr = -1, this.typingTimeout = 0;
      const {
        dialog: t,
        term: a,
        debounceRate: i
      } = this.props;
      this.state = {
        showPredictiveText: !0,
        activeSuggestion: -1,
        categorizedResults: [],
        predictiveTextValue: "",
        data: {},
        menu: t,
        results: [],
        searchTerm: a,
        showResults: !0
      }, this.handleChange = this.handleChange.bind(this), this.handleKeyPress = this.handleKeyPress.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleKeyUp = this.handleKeyUp.bind(this), this.handleResultItemSelect = this.handleResultItemSelect.bind(this), this.focusInput = this.focusInput.bind(this), this.announceResults = this.announceResults.bind(this), this.onDismiss = this.onDismiss.bind(this), this.updateResults = this.updateResults.bind(this), this.updateResultsDebounced = i && i > 0 ? (0, P.debounce)(i, this.updateResults) : this.updateResults, this.menuOpened = this.menuOpened.bind(this), this.menuClosed = this.menuClosed.bind(this), this.resetActiveSuggestion = this.resetActiveSuggestion.bind(this), this.handleRemoveRecentSearch = this.handleRemoveRecentSearch.bind(this), this.resultsDomRef = T.createRef();
    }
    componentDidUpdate(e, t) {
      const {
          searchTerm: a,
          results: i,
          showResults: s
        } = this.state,
        {
          label: n,
          l10n: l,
          value: r,
          dialog: o
        } = this.props,
        c = i && i.length,
        d = this.isTypeAheadFocused();
      Ge(r) && Ge(a) && d && (0, w.liveAnnounce)(l.formatText("typeahead.announceResults.trigerLabel", n)), t.searchTerm === a && !Ge(r) && !1 === this.keyPressed && d && (0, w.liveAnnounce)(l.formatText("typeahead.announceResults.showingResults", n, c, a)), t.searchTerm !== a && o && s && (this.setState({
        results: qe.placeholder
      }), this.updateResultsDebounced(a)), this.focusInput();
    }
    handleResultItemSelect(e, t, a) {
      var _a;
      const {
          adapter: i,
          isMulti: s,
          onResultItemSelect: n,
          label: l,
          l10n: r,
          predictiveText: o
        } = this.props,
        {
          searchTerm: c
        } = this.state;
      return (_a = i.onItemSelection) === null || _a === void 0 ? void 0 : _a.call(i, t).then(i => {
        s ? this.setState({
          activeSuggestion: -1
        }) : this.setState({
          activeSuggestion: -1,
          searchTerm: e,
          showResults: !1
        }), n(e, i, t);
        const d = a ? se(a) - 1 : 0;
        s && (0, w.liveAnnounce)(`${r.formatText("typeahead.announceResults.itemSelected", e)}\n             ${r.formatText("typeahead.announceResults.showingResults", l, d, c)}`), s || (setTimeout(() => {
          (0, w.liveAnnounce)(`${r.formatText("typeahead.announceResults.itemSelected", e)} \n            ${r.formatText("typeahead.announceResults.menuClosed")}`);
        }, 100), o || this.menuClosed());
      }).catch(() => {
        this.updateResults(e, !0, "" !== e), this.menuClosed();
      });
    }
    handleAnnounceResults(e) {
      this.typingTimeout && clearTimeout(this.typingTimeout), (e === null || e === void 0 ? void 0 : e.length) > 0 && (this.typingTimeout = setTimeout(() => {
        this.announceResults(e);
      }, 1e3));
    }
    handleKeyPress(e) {
      const {
          activeSuggestion: t,
          searchTerm: a,
          predictiveTextValue: i
        } = this.state,
        {
          value: s,
          l10n: n
        } = this.props;
      this.keyPressed = !0;
      const l = ne(this.getResultsToShow(), Array.isArray(s) ? s : []),
        r = l && se(l);
      this.keyPressed = !0;
      const o = a && a.split("");
      if (o) {
        const e = `'${o.join("' , '")} '`;
        "" !== a && r > 0 && (0, w.liveAnnounce)(n.formatText("typeahead.announceResults.resultsAvailable", e, r));
      }
      if ("Enter" !== e.key && 38 !== e.keyCode || e.preventDefault(), "Enter" === e.key) {
        const e = i.length > 0 && -1 === t ? le(l, 0) : le(l, t);
        e ? this.handleResultItemSelect(e.value, e.data, l) : this.handleResultItemSelect(a, void 0, l);
      }
    }
    handlePredictiveClose() {
      const e = ne(this.getResultsToShow(), []),
        t = le(e, 0);
      this.handleResultItemSelect(t.value, t.data, e);
    }
    handleChange(e) {
      const {
          handleType: t
        } = this.props,
        a = e.target.value;
      this.setState({
        searchTerm: a,
        showResults: !0,
        predictiveTextValue: ""
      }, this.focusInput), "" === a && this.resetActiveSuggestion(), t(a);
    }
    handleActiveSuggestion(e) {
      const {
          activeSuggestion: t,
          results: a,
          searchTerm: i
        } = this.state,
        {
          allowExactMatch: s
        } = this.props,
        n = s && i ? 1 : 0,
        l = a.length + n;
      let r = 0;
      e === Ye.UP ? r = -1 === t ? l : l - 1 : e === Ye.DOWN && (r = l + 1);
      const o = (t + r) % l,
        c = (this.newAttr + r) % l;
      this.setState({
        activeSuggestion: this.newAttr > -1 ? c : o
      }), this.newAttr = -1;
    }
    handleUpArrowKey(e) {
      38 === e.keyCode && (e.preventDefault(), this.handleActiveSuggestion(Ye.UP));
    }
    handleDownArrowKey(e) {
      40 === e.keyCode && (this.keyPressed = !0, this.handleActiveSuggestion(Ye.DOWN));
    }
    handleTabKey(e) {
      if (9 === e.keyCode || e.shiftKey && 9 === e.keyCode) {
        const t = e.target.parentElement.getAttribute("data-index");
        this.newAttr = t ? Number(t) : -1;
      }
    }
    handleEscKey(e) {
      27 === e.keyCode && this.onDismiss();
    }
    handleDelete(e) {
      8 === e.keyCode ? this.resetActiveSuggestion() : this.setState({
        showPredictiveText: !0
      });
    }
    handleKeyDown(e) {
      this.handleDownArrowKey(e), this.handleUpArrowKey(e), this.handleEscKey(e), this.handleDelete(e);
    }
    handleKeyUp(e) {
      this.handleTabKey(e);
    }
    handleRemoveRecentSearch(e) {
      this.setState(t => Object.assign(Object.assign({}, t), {
        results: this.filterTypeaheadResult(e, t.results),
        categorizedResults: t.categorizedResults.map(t => Object.assign(Object.assign({}, t), {
          typeaheadResults: this.filterTypeaheadResult(e, t.typeaheadResults)
        })).filter(e => e.typeaheadResults.length >= 1)
      })), this.removeRecentSearch(e);
    }
    onDismiss() {
      const {
        isMulti: e,
        onDismiss: t,
        l10n: a
      } = this.props;
      this.keyPressed = !1, this.resultsDomRef.current && (this.resultsDomRef.current.scrollTop = 0), t === null || t === void 0 ? void 0 : t(), e && (0, w.liveAnnounce)(a.formatText("typeahead.announceResults.menuClosed"));
    }
    getResultsToShow() {
      const {
          categorize: e
        } = this.props,
        {
          categorizedResults: t,
          results: a
        } = this.state;
      return e || t && t.length ? {
        items: t,
        type: "categorized"
      } : {
        items: a,
        type: "uncategorized"
      };
    }
    static getDerivedStateFromProps(e, t) {
      const a = e.term === t.searchTerm || e.dialog ? t.searchTerm : e.term;
      return e.isMulti ? null : {
        searchTerm: a
      };
    }
    filterTypeaheadResult(e, t) {
      return t.filter(t => {
        const a = t.data;
        return (a === null || a === void 0 ? void 0 : a.regionId) === e && "USERHISTORY" === (a === null || a === void 0 ? void 0 : a.category) ? null : t;
      });
    }
    menuClosed() {
      const {
          onDismiss: e,
          predictiveText: t
        } = this.props,
        {
          predictiveTextValue: a,
          activeSuggestion: i
        } = this.state;
      a.length > 0 && -1 === i && t && this.handlePredictiveClose(), e === null || e === void 0 ? void 0 : e(), this.resetActiveSuggestion();
    }
    menuOpened() {
      const {
        searchTerm: e
      } = this.state;
      this.resultsDomRef.current && (this.resultsDomRef.current.scrollTop = 0), this.selectInput(), this.updateResults(e, !1, "" !== e);
    }
    announceResults(e) {
      const {
          searchTerm: t
        } = this.state,
        {
          l10n: a
        } = this.props,
        i = t && t.split("");
      if (i) {
        const t = `'${i.join("' , '")} '`;
        e && this.isTypeAheadFocused() && (0, w.liveAnnounce)(a.formatText("typeahead.announceResults.resultsAvailable", t, e.length));
      }
    }
    isCategorizedResult(e) {
      return "heading" in e;
    }
    removeRecentSearch(e) {
      return __awaiter(this, void 0, void 0, function* () {
        const {
          adapter: t
        } = this.props;
        yield t.fetchDeleteRecentSearch(e);
      });
    }
    updateResults(e, t, a) {
      return __awaiter(this, void 0, void 0, function* () {
        this.lastSearchTerm = e;
        const {
            adapter: i,
            categorize: s,
            resultsRequestDurationTimeCallback: n,
            predictiveText: l,
            onRecommendationImpression: r
          } = this.props,
          {
            showPredictiveText: o
          } = this.state;
        let c, d, u, h;
        const m = e,
          p = performance.now();
        if ("" !== m && t) [u, h] = s ? yield Promise.all([i.fetchResultsCategorized(m), i.fetchRecentSearchResultsCategorized()]) : yield Promise.all([i.fetchResults(m), i.fetchRecentSearchResults()]), h && h.length > 0 ? s || this.isCategorizedResult(h[0]) ? d = h : c = h : s ? d = u : c = u;else if (s) d = yield i.fetchResultsCategorized(m);else if ("" !== m && a) {
          const e = yield i.fetchAlternativeResults(m);
          e && e.length && this.isCategorizedResult(e[0]) ? d = e : c = e;
        } else {
          const e = yield i.fetchResults(m);
          e && e.length && this.isCategorizedResult(e[0]) ? d = e : c = e;
        }
        if (n === null || n === void 0 ? void 0 : n(performance.now() - p, "" !== m.trim()), this.lastSearchTerm === e) if (c && c.length) {
          if (r === null || r === void 0 ? void 0 : r(t || a ? "" : e), this.setState({
            results: c,
            categorizedResults: []
          }, () => {
            this.handleAnnounceResults(c);
          }), l && o) {
            this.resetActiveSuggestion();
            const t = $e(m, c[0].title);
            e.length > 0 && this.setState({
              predictiveTextValue: t
            });
          }
        } else if (d && d.length) {
          r === null || r === void 0 ? void 0 : r(t || a ? "" : e);
          const i = d.flatMap(e => e.typeaheadResults);
          this.setState({
            categorizedResults: d,
            results: i
          }, () => {
            this.handleAnnounceResults(c);
          });
        } else this.setState({
          results: [],
          categorizedResults: []
        });
      });
    }
    selectInput() {
      const {
        toolbarInputRef: e
      } = this;
      e && e.current && "function" == typeof e.current.select && e.current.select();
    }
    focusInput() {
      const {
        toolbarInputRef: e
      } = this;
      e && e.current && "function" == typeof e.current.focus && (0, w.isElementVisible)(this.toolbarInputRef.current) && e.current.focus();
    }
    resetActiveSuggestion() {
      this.setState({
        activeSuggestion: -1,
        predictiveTextValue: "",
        showPredictiveText: !1
      });
    }
    isTypeAheadFocused() {
      return this.toolbarInputRef.current === document.activeElement;
    }
    render() {
      const {
          allowExactMatch: e,
          children: t,
          dialog: a,
          stid: i,
          label: s,
          listTitle: n,
          placeholder: l,
          handleClear: r,
          emptyResultPlaceholder: o,
          dismissButtonText: c,
          value: d,
          isMulti: u,
          clearAllText: h,
          onClearAll: m,
          onItemRemove: p,
          selectedItemHeading: g,
          typeaheadInputRef: y,
          historyDetail: f,
          required: R,
          allowToRemoveRecentSearches: v,
          predictiveText: E
        } = this.props,
        {
          activeSuggestion: S,
          searchTerm: b,
          predictiveTextValue: k
        } = this.state,
        I = this.getResultsToShow();
      return T.createElement("div", {
        className: We("uitk-menu-typeahead-wrapper")
      }, T.createElement("div", {
        className: We("uitk-typeahead-menu"),
        id: i && `${i}-menu`
      }, T.createElement("div", {
        className: We("uitk-menu-trigger")
      }, t), T.createElement(Y.UitkSheetTransition, {
        isVisible: a,
        openCallback: this.menuOpened
      }, T.createElement(Y.UitkSheet, {
        autoFocus: !1,
        type: "popover",
        className: We("uitk-typeahead-menu-container", {
          "is-multi": u
        }),
        disableArrowKeyHandler: !0,
        isVisible: a,
        onDismiss: this.menuClosed,
        triggerRef: y,
        showOverTrigger: !0,
        autoPosition: !1
      }, T.createElement(W.UitkLayoutFlex, {
        direction: "column",
        blockSize: "full_size"
      }, T.createElement(W.UitkLayoutFlexItem, null, T.createElement("div", {
        className: We("uitk-typeahead-input-wrapper"),
        id: "search-location-input-field"
      }, E ? T.createElement(Fe, {
        autoComplete: "off",
        "data-stid": i && `${i}-dialog-input`,
        domRef: this.toolbarInputRef,
        hasClearButton: b.length > 0,
        hasFloatedLabel: !1,
        hasVisibleLabel: !1,
        id: i,
        label: s,
        onChange: this.handleChange,
        placeholder: l,
        value: b,
        onKeyPress: this.handleKeyPress,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        handleClear: r,
        required: R,
        predictiveText: k
      }) : T.createElement(ce, {
        className: We("uitk-typeahead-input-v2"),
        "data-stid": i && `${i}-menu-input`,
        domRef: this.toolbarInputRef,
        handleClear: r,
        hasClearButton: b.length > 0,
        hasFloatedLabel: !1,
        hasVisibleLabel: !1,
        id: i,
        label: s,
        onChange: this.handleChange,
        onKeyPress: this.handleKeyPress,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        placeholder: l,
        required: R,
        value: b
      }))), T.createElement(W.UitkLayoutFlexItem, null, T.createElement(Y.UitkSheetContent, {
        className: We("uitk-typeahead-menu-content"),
        padded: !1
      }, T.createElement(we, {
        typeaheadLabel: s,
        allowExactMatch: e,
        onResultItemSelect: this.handleResultItemSelect,
        handleRemoveRecentSearch: this.handleRemoveRecentSearch,
        results: I,
        searchTerm: b,
        stid: i,
        listTitle: n,
        activeSuggestion: S,
        emptyResultPlaceholder: o,
        isMulti: u,
        dismissButtonText: c,
        selectedItemHeading: g,
        clearAllText: h,
        onClearAll: m,
        onItemRemove: p,
        value: d,
        domRef: this.resultsDomRef,
        historyDetail: f,
        allowToRemoveRecentSearches: v
      }))), u && T.createElement(W.UitkLayoutFlexItem, null, T.createElement(W.UitkLayoutFlex, {
        justifyContent: "end",
        className: We("uitk-typeahead-menu-footer")
      }, T.createElement(W.UitkLayoutFlexItem, null, T.createElement(H.UitkPrimaryButton, {
        disabled: 0 === (d === null || d === void 0 ? void 0 : d.length),
        onClick: this.onDismiss
      }, c)))))))));
    }
  }
  qe.placeholder = [{
    disabled: !0,
    icon: "brightness_1",
    name: " ",
    value: " ",
    title: " "
  }];
  const je = e => {
      const t = (0, V.useLocalization)();
      return T.createElement(qe, Object.assign({
        l10n: t
      }, e));
    },
    Qe = w.classNames.bind(re);
  var Ze;
  !function (e) {
    e.MENU = "menu", e.DIALOG = "dialog";
  }(Ze || (Ze = {}));
  const Je = e => {
    const {
        isMulti: t = !1,
        value: a,
        onMountCB: i,
        stid: s,
        handleClear: n,
        onUpdate: l,
        onType: r,
        onResultSelection: o,
        id: c,
        allowExactMatch: d,
        label: u,
        listTitle: h,
        categorize: m,
        typeaheadPlaceholder: p,
        typeaheadEmptyResultPlaceholder: g,
        dismissButtonText: y,
        clearAllText: f,
        onItemRemove: R,
        selectedItemHeading: v,
        debounceRate: E,
        required: S,
        onClick: b,
        onDismiss: k,
        adapter: I,
        accessibilityLabel: x,
        icon: A,
        invalid: C,
        name: U,
        placeholder: N,
        allowToRemoveRecentSearches: L,
        resultsRequestDurationTimeCallback: D,
        resultItemImpressionTracker: P,
        onResultItemImpression: z,
        predictiveText: O = !1
      } = e,
      [M, F] = T.default.useState({
        dialog: !1,
        mounted: !1,
        searchTerm: "",
        startSearchTerm: "",
        results: []
      }),
      _ = (0, V.useLocalization)();
    I.setL10n(_);
    const $ = T.default.useRef();
    T.default.useEffect(() => {
      t && F(e => Object.assign(Object.assign({}, e), {
        searchTerm: ""
      })), a !== M.searchTerm && "string" == typeof a && F(e => Object.assign(Object.assign({}, e), {
        searchTerm: a !== null && a !== void 0 ? a : ""
      })), m && I.setTypeaheadCategories();
    }, [t, a, M.searchTerm, m, I]), T.default.useEffect(() => {
      Array.isArray(a) && t && F(e => Object.assign(Object.assign({}, e), {
        searchTerm: a.join(", ")
      })), F(e => Object.assign(Object.assign({}, e), {
        mounted: !0
      })), i && i($);
    }, []);
    const H = () => {
        F(e => Object.assign(Object.assign({}, e), {
          searchTerm: ""
        })), n === null || n === void 0 ? void 0 : n();
      },
      W = e => {
        r === null || r === void 0 ? void 0 : r(e);
      },
      G = (e, a, i) => {
        var _a, _b;
        if (l === null || l === void 0 ? void 0 : l({
          selection: {
            term: e,
            data: a
          },
          selectionData: i
        }), o) {
          const t = new CustomEvent("change"),
            i = document.createElement("input");
          i.value = e, i.setAttribute("id", (_a = a === null || a === void 0 ? void 0 : a.id) !== null && _a !== void 0 ? _a : c), i.addEventListener("change", e => {
            o(e);
          }), i.dispatchEvent(t);
        }
        t || (F(t => Object.assign(Object.assign({}, t), {
          searchTerm: e
        })), (0, w.liveAnnounce)(_.formatText("typeahead.enteringInput")), (_b = $.current) === null || _b === void 0 ? void 0 : _b.focus());
      },
      Y = e => {
        z === null || z === void 0 ? void 0 : z(e);
      },
      q = e => {
        const t = (0, w.isElementVisible)($.current),
          a = {
            renderType: e
          };
        k === null || k === void 0 ? void 0 : k(a), F(e => Object.assign(Object.assign({}, e), {
          dialog: !1,
          startSearchTerm: ""
        })), $.current && t && $.current.focus();
      },
      j = e => {
        const {
            dialog: i
          } = M,
          n = i,
          l = e === Ze.MENU ? "uitk-typeahead-menu-layer" : "uitk-typeahead-dialog-layer",
          r = e === Ze.MENU ? "uitk-typeahead-menu-layer-responsive" : "uitk-typeahead-dialog-layer-responsive";
        return T.default.createElement(T.default.Fragment, null, T.default.createElement("div", {
          className: Qe(l, {
            [r]: n,
            "is-hidden": !n
          })
        }, (e => {
          const {
              dialog: i,
              searchTerm: n,
              startSearchTerm: l
            } = M,
            r = {
              isMulti: t,
              value: a,
              label: u,
              adapter: I,
              allowExactMatch: d,
              onResultItemSelect: G,
              dialog: i,
              stid: s,
              placeholder: p,
              term: n,
              emptyResultPlaceholder: g,
              listTitle: h,
              categorize: m,
              handleClear: H,
              handleType: W,
              clearAllText: f,
              onClearAll: H,
              dismissButtonText: y !== null && y !== void 0 ? y : _.formatText("typeahead.multiselect.dismiss"),
              onItemRemove: R,
              selectedItemHeading: v,
              debounceRate: E,
              typeaheadInputRef: $,
              historyDetail: I.getConfig().historyDetail,
              required: S,
              allowToRemoveRecentSearches: L,
              resultsRequestDurationTimeCallback: D,
              onRecommendationImpression: Y,
              predictiveText: O
            };
          return e === Ze.MENU ? T.default.createElement(je, Object.assign(Object.assign({}, r), {
            onDismiss: () => {
              q(e);
            }
          })) : T.default.createElement(He, Object.assign(Object.assign({}, r), {
            id: c,
            onDismiss: () => {
              q(Ze.DIALOG);
            },
            startSearchTerm: l
          }));
        })(e)), (e => {
          const {
              mounted: i,
              searchTerm: n,
              dialog: l
            } = M,
            r = x || u,
            o = e === Ze.MENU ? K.UitkTextInput : ce;
          return T.default.createElement("div", null, i && T.default.createElement(K.UitkFakeInput, {
            "aria-label": [r, n].filter(e => e && e.length > 0).join(" "),
            "aria-expanded": l,
            icon: A,
            label: u,
            handleClear: H,
            "aria-describedby": C && s ? `${s}-input-error` : void 0,
            "data-stid": s && e === Ze.MENU ? `${s}-menu-trigger` : s && "dialog" === e ? `${s}-dialog-trigger` : "",
            domRef: $,
            onClick: () => {
              (e => {
                const {
                    dialog: t,
                    searchTerm: a
                  } = M,
                  i = t,
                  s = {
                    renderType: e,
                    prefillText: a && "" !== a ? a : void 0
                  };
                e === Ze.MENU ? i ? q(e) : (b === null || b === void 0 ? void 0 : b(s), F(e => Object.assign(Object.assign({}, e), {
                  dialog: !0
                }))) : e === Ze.DIALOG && (b === null || b === void 0 ? void 0 : b(s), F(e => Object.assign(Object.assign({}, e), {
                  dialog: !0
                })));
              })(e);
            },
            placeholder: N,
            value: t ? a.join(", ") : a,
            invalid: C,
            required: S
          }), T.default.createElement(o, {
            className: Qe({
              "is-hidden": i
            }),
            icon: A,
            label: u,
            "data-stid": s && `${s}-input`,
            domRef: $,
            hasClearButton: !1,
            name: U,
            placeholder: N,
            value: n,
            id: s && `${s}-input`,
            required: S
          }));
        })(e));
      },
      Q = T.default.useMemo(() => ({
        impressionWrapper: P
      }), [P]);
    return T.default.createElement(fe.Provider, {
      value: Q
    }, T.default.createElement("div", {
      className: Qe("uitk-typeahead"),
      "data-stid": s
    }, T.default.createElement(B.Viewport, null, T.default.createElement(B.ViewSmall, null, j(Ze.DIALOG)), T.default.createElement(B.ViewLarge, null, j(Ze.MENU)))));
  };
  Je.displayName = "TypeaheadCustom";
  const Xe = (e => {
    var t = {};
    return S.d(t, e), t;
  })({
    useDialog: () => v.useDialog
  });
  var et = (0, xe.__spreadArray)((0, xe.__spreadArray)([], [["xsmall", "gap-xsmall"], ["small", "gap-small"], ["medium", "gap-medium"], ["large", "gap-large"], ["xlarge", "gap-xlarge"]], !0), [["half", "gap-half"], ["one", "gap-one"], ["two", "gap-two"], ["three", "gap-three"], ["four", "gap-four"], ["six", "gap-six"], ["twelve", "gap-twelve"]], !0),
    tt = (new Map(et), new Map([["zero", "zero"], ["fifteen", "fifteen"], ["sixteen", "sixteen"], ["twenty_four", "twenty_four"], ["seventy_two", "seventy_two"], ["seventy_six", "seventy_six"], ["eighty_eight", "eighty_eight"], ["ninety_six", "ninety_six"], ["one_hundred_four", "one_hundred_four"], ["one_hundred_twelve", "one_hundred_twelve"], ["one_hundred_twenty", "one_hundred_twenty"]]), new Map([["full_width", "full_width"], ["half_width", "half_width"], ["third_width", "third_width"], ["quarter_width", "quarter_width"]]), new Map([["zero", "zero"], ["fifteen", "fifteen"], ["sixteen", "sixteen"], ["twenty_four", "twenty_four"], ["seventy_two", "seventy_two"], ["seventy_six", "seventy_six"], ["eighty_eight", "eighty_eight"], ["ninety_six", "ninety_six"], ["one_hundred_four", "one_hundred_four"], ["one_hundred_twelve", "one_hundred_twelve"], ["one_hundred_twenty", "one_hundred_twenty"], ["full_width", "full_width"], ["half_width", "half_width"], ["third_width", "third_width"], ["quarter_width", "quarter_width"]]), new Map([["article", "article"], ["aside", "aside"], ["div", "div"], ["footer", "footer"], ["header", "header"], ["section", "section"], ["ul", "ul"], ["ol", "ol"], ["li", "li"], ["main", "main"]])),
    at = S(904),
    it = S.n(at),
    st = new Map([["none", "pointerevents-none"]]),
    nt = new Map([["relative", "relative"], ["sticky", "sticky"], ["absolute", "absolute"], ["fixed", "fixed"]]),
    lt = (new Map([["layer1", "layer1"], ["layer2", "layer2"], ["layer3", "layer3"], ["layer4", "layer4"], ["layer5", "layer5"], ["layer6", "layer6"], ["layer7", "layer7"]]), new Map([["zero", "zero"], ["half", "half"], ["one", "one"], ["two", "two"], ["three", "three"], ["four", "four"], ["six", "six"], ["twelve", "twelve"], ["minus-half", "minus-half"], ["minus-one", "minus-one"], ["minus-two", "minus-two"], ["minus-three", "minus-three"], ["minus-four", "minus-four"], ["minus-six", "minus-six"], ["minus-twelve", "minus-twelve"], ["center", "center"]]), w.classNames.bind(it())),
    rt = function (e) {
      var t = e.children,
        a = e.className,
        i = e.cloneElement,
        s = e.display,
        n = e.pointerEvents,
        l = e.position,
        r = e.style,
        o = e.tag,
        c = e.type,
        d = (0, xe.__rest)(e, ["children", "className", "cloneElement", "display", "pointerEvents", "position", "style", "tag", "type"]),
        u = T.useMemo(function () {
          return l && Object.values(l).some(function (e) {
            return "number" == typeof e;
          }) && c === nt.get("sticky");
        }, [l, c]),
        h = T.Children.toArray(t)[0];
      if (!h || !1 === T.isValidElement(h)) return null;
      var m = h.props.className,
        p = h.props.style,
        g = "uitk-layout-position",
        y = lt(g, i && m && m, s && "".concat(g, "-display-").concat(s), n && "".concat(g, "-").concat(st.get(n)), l && Object.entries(l).filter(function (e) {
          return "string" == typeof e[1];
        }).map(function (e) {
          var t = e[0],
            a = e[1];
          return "".concat(g, "-").concat(t, "-").concat(a);
        }).join(" "), c && "".concat(g, "-").concat(nt.get(c)), u && "".concat(g, "-custom"), a),
        f = (0, xe.__assign)((0, xe.__assign)({}, p), r);
      l && u && Object.entries(l).forEach(function (e) {
        var t = e[0],
          a = e[1];
        "number" == typeof a && (f["--uitk-custom-".concat(t, "-position")] = "".concat(a, "px"));
      });
      var R = T.cloneElement(h, (0, xe.__assign)((0, xe.__assign)({
          className: y
        }, Object.keys(f).length && {
          style: f
        }), d)),
        v = o && tt.get(o) || tt.get("div");
      return i ? R : T.createElement(v, (0, xe.__assign)({
        className: y
      }, d, {
        style: f
      }), " ", t || null, " ");
    };
  rt.displayName = "UitkLayoutPosition";
  const ot = e => {
      const {
          results: t
        } = e,
        a = e => {
          var _a, _b;
          return (_b = (_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.category) !== null && _b !== void 0 ? _b : "";
        },
        i = e => e.find(e => {
          var _a;
          return (_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.category;
        }),
        s = "categorized" === t.type ? (e => {
          const t = e.find(e => i(e === null || e === void 0 ? void 0 : e.typeaheadResults));
          return (t === null || t === void 0 ? void 0 : t.typeaheadResults) ? a(t === null || t === void 0 ? void 0 : t.typeaheadResults[0]) : "";
        })(t.items) : a(i(t.items));
      return s === Q ? T.createElement(he.UitkSpacing, {
        padding: {
          block: "three",
          inline: "four"
        }
      }, T.createElement("div", null, s === Q && T.createElement("img", {
        src: pe,
        alt: "Powered by Google Logo"
      }))) : null;
    },
    ct = e => {
      const {
          data: t,
          onResultItemSelect: a,
          value: i,
          className: s,
          subtext: n,
          activeSuggestion: l,
          name: r,
          contentRef: o,
          icon: c,
          historyDetail: d,
          sanitized: u,
          stid: h,
          index: m,
          handleRemoveRecentSearch: p,
          allowToRemoveRecentSearches: g,
          isNestedChild: y
        } = e,
        {
          formatText: f
        } = (0, V.useLocalization)(),
        R = n ? `${r} ${n}`.replace(/(<([^>]+)>)/gi, "") : r === null || r === void 0 ? void 0 : r.replace(/(<([^>]+)>)/gi, ""),
        v = `full-search-detail-${d || !1}`,
        E = "USERHISTORY" === (t === null || t === void 0 ? void 0 : t.category),
        S = !!(t === null || t === void 0 ? void 0 : t.popularFilter),
        b = f("typeahead.custom.delete.recent.search.button.label.a11y", i),
        k = f("typeahead.custom.delete.recent.search.button.announce.a11y", i);
      if (!0 === l) {
        const e = r.replace(/(<([^>]+)>)/gi, "");
        (0, w.liveAnnounce)(`${e}`, void 0, void 0, o);
      }
      const I = u ? T.createElement("span", null, r) : T.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: r
          }
        }),
        A = !u && n && T.createElement("div", {
          "data-stid": v,
          dangerouslySetInnerHTML: {
            __html: n
          }
        }),
        {
          impressionWrapper: C
        } = T.useContext(fe),
        U = C !== null && C !== void 0 ? C : T.Fragment,
        N = Re({
          isPopularFilter: S,
          isUserHistory: E
        }),
        L = `${N}.Presented.${S ? `${i} - ${n.replace(/(<([^>]+)>)/gi, "")}` : i}`,
        D = C ? {
          linkNameSuffix: N,
          referrerIdSuffix: L
        } : {};
      return T.createElement(U, Object.assign({}, D), T.createElement(de.UitkActionListItem, {
        spacing: "relaxed",
        className: s,
        "data-stid": h && `${h}-result-item`,
        "data-index": m,
        active: l
      }, T.createElement(he.UitkSpacing, {
        padding: {
          inlinestart: y ? "eight" : "unset"
        }
      }, T.createElement("div", null, T.createElement(de.UitkActionListItemLink, null, T.createElement("button", {
        "data-stid": h && `${h}-result-item-button`,
        onClick: () => {
          a(i, t);
        },
        "aria-label": R,
        type: "button"
      })), T.createElement("div", null, T.createElement(W.UitkLayoutFlex, null, c && T.createElement(W.UitkLayoutFlexItem, {
        alignSelf: "center"
      }, T.createElement(x.UitkIcon, {
        name: c,
        size: x.UitkIconSize.MEDIUM
      })), T.createElement(W.UitkLayoutFlexItem, null, T.createElement(he.UitkSpacing, {
        margin: {
          inlinestart: "two"
        }
      }, T.createElement("div", null, T.createElement(ue.UitkText, {
        size: 300,
        overflow: "truncate"
      }, I), T.createElement(ue.UitkText, {
        size: 300,
        overflow: "truncate"
      }, A)))), E && g && !S && T.createElement(W.UitkLayoutFlexItem, {
        alignSelf: "center",
        grow: 1
      }, T.createElement(W.UitkLayoutFlex, {
        justifyContent: "end"
      }, T.createElement(H.UitkTertiaryButton, {
        onClick: () => {
          p(t === null || t === void 0 ? void 0 : t.regionId), (0, w.liveAnnounce)(1 === k.length ? `${r} was deleted from recent searches` : k);
        },
        "aria-label": 0 === b.length ? `Delete ${i} from recent searches` : b
      }, T.createElement(x.UitkIcon, {
        name: "close",
        size: x.UitkIconSize.SMALL
      }))))))))));
    };
  ct.displayName = "TypeaheadCustomResultItem";
  const dt = e => {
      const {
          headingText: t,
          hideHeading: a = !1,
          typeaheadLabel: i,
          stid: s = "",
          values: n,
          onItemRemove: l,
          onClear: r,
          clearAllText: o
        } = e,
        c = (0, V.useLocalization)(),
        d = o !== null && o !== void 0 ? o : c.formatText("typeahead.mulselect.clearAll"),
        u = t !== null && t !== void 0 ? t : c.formatText("typeahead.multiselect.selectedItemHeading");
      return T.createElement("div", null, !a && u && (n === null || n === void 0 ? void 0 : n.length) > 0 && T.createElement(he.UitkSpacing, {
        padding: {
          inlinestart: "four"
        }
      }, T.createElement("div", null, T.createElement(ue.UitkText, {
        overflow: "truncate",
        size: 300,
        weight: "bold"
      }, u))), T.createElement(he.UitkSpacing, {
        padding: {
          blockstart: "three",
          inline: "four"
        }
      }, T.createElement("div", {
        "data-stid": s
      }, n === null || n === void 0 ? void 0 : n.map((e, t) => T.createElement(he.UitkSpacing, {
        key: `${s}-pill-${t}`,
        margin: {
          block: "one"
        }
      }, T.createElement(I.UitkRemovablePill, {
        onClick: () => ((e, t) => {
          (0, w.liveAnnounce)(c.formatText("typeahead.removeSelection", e)), l === null || l === void 0 ? void 0 : l(t);
        })(e, t),
        id: `${s}-pill-${t}`
      }, e))), (n === null || n === void 0 ? void 0 : n.length) && T.createElement(H.UitkTertiaryButton, {
        onClick: () => {
          (0, w.liveAnnounce)(c.formatText("typeahead.clearAllSelections", i)), r === null || r === void 0 ? void 0 : r();
        },
        size: H.UitkButtonSize.SMALL
      }, d))));
    },
    ut = e => {
      const {
          activeSuggestion: t,
          allowExactMatch: a,
          listTitle: i,
          typeaheadLabel: s,
          onResultItemSelect: n,
          results: l,
          searchTerm: r,
          stid: o,
          emptyResultPlaceholder: c,
          isMulti: d,
          onClearAll: u,
          onItemRemove: h,
          clearAllText: m,
          selectedItemHeading: p,
          value: g,
          domRef: y,
          contentRef: f,
          historyDetail: R,
          allowToRemoveRecentSearches: v,
          handleRemoveRecentSearch: E
        } = e,
        S = (0, V.useLocalization)(),
        b = d ? ne(l, g) : l,
        k = se(b),
        I = d && g.length > 0 ? T.createElement(dt, {
          typeaheadLabel: s,
          values: g,
          stid: o,
          clearAllText: m,
          onClear: u,
          onItemRemove: h,
          headingText: p
        }) : null,
        w = (e, t) => {
          n(e, t, b);
        },
        A = e => {
          var _a;
          return (_a = e[0]) === null || _a === void 0 ? void 0 : _a.disabled;
        },
        C = e => {
          var _a, _b;
          return (_b = (_a = e[0]) === null || _a === void 0 ? void 0 : _a.typeaheadResults[0]) === null || _b === void 0 ? void 0 : _b.disabled;
        },
        U = T.createElement(he.UitkSpacing, {
          padding: {
            inlinestart: "six"
          }
        }, T.createElement("div", null, T.createElement(he.UitkSpacing, {
          margin: {
            blockstart: "four"
          }
        }, T.createElement(me.UitkLineSkeleton, null)), T.createElement(he.UitkSpacing, {
          margin: {
            block: "eight"
          }
        }, T.createElement(me.UitkLineSkeleton, null)), T.createElement(me.UitkLineSkeleton, null))),
        N = c && T.createElement(W.UitkLayoutFlex, {
          justifyContent: "center",
          alignContent: "center"
        }, T.createElement(ue.UitkText, {
          align: "center"
        }, T.createElement(he.UitkSpacing, {
          margin: {
            blockstart: "six"
          }
        }, T.createElement(x.UitkIcon, {
          name: "search",
          size: x.UitkIconSize.XLARGE
        })), T.createElement(he.UitkSpacing, {
          margin: {
            blockend: "three"
          }
        }, T.createElement(ue.UitkText, {
          size: 300
        }, c)))),
        L = a && r && !(e => {
          switch (e.type) {
            case "categorized":
              return C(e.items);
            case "uncategorized":
              return A(e.items);
          }
        })(b) && T.createElement(ct, {
          icon: "search",
          name: S.formatText("typeahead.searchFor", [r]),
          onResultItemSelect: w,
          handleRemoveRecentSearch: E,
          index: k,
          stid: o,
          value: r,
          allowToRemoveRecentSearches: v,
          sanitized: !0,
          activeSuggestion: !(-1 === t || t !== k),
          historyDetail: R
        }),
        D = (e => {
          switch (e.type) {
            case "categorized":
              return C(e.items) ? U : (e => {
                const a = e === null || e === void 0 ? void 0 : e.map(e => e.typeaheadResults.length > 0 ? T.createElement(T.Fragment, {
                  key: e.heading
                }, e.heading && T.createElement(he.UitkSpacing, {
                  padding: {
                    block: "three",
                    inlinestart: "six"
                  }
                }, T.createElement("li", null, T.createElement(ue.UitkText, {
                  overflow: "truncate",
                  size: 300,
                  weight: "bold"
                }, e.heading))), e.typeaheadResults && e.typeaheadResults.map((e, a) => {
                  var _a;
                  return T.createElement(ct, {
                    data: e.data,
                    key: a,
                    index: a,
                    icon: e.icon,
                    name: e.name,
                    handleRemoveRecentSearch: E,
                    onResultItemSelect: w,
                    stid: o,
                    value: e.value,
                    subtext: e.subtext,
                    allowToRemoveRecentSearches: v,
                    activeSuggestion: -1 !== t && t === ((_a = e.data) === null || _a === void 0 ? void 0 : _a.index),
                    historyDetail: R
                  });
                })) : null);
                return a.filter(e => null !== e).length > 0 ? a : null;
              })(e.items);
            case "uncategorized":
              return A(e.items) ? U : (e => {
                const a = e.map((e, a) => {
                  var _a;
                  const s = e.data && (e.isChild || ((_a = e.data) === null || _a === void 0 ? void 0 : _a.popularFilter));
                  return T.createElement(T.Fragment, {
                    key: a
                  }, i && T.createElement(he.UitkSpacing, {
                    padding: {
                      block: "three",
                      inlinestart: "six"
                    }
                  }, T.createElement("li", null, T.createElement(ue.UitkText, {
                    overflow: "truncate",
                    size: 300,
                    weight: "bold"
                  }, e.title))), T.createElement(ct, {
                    data: e.data,
                    key: a,
                    index: a,
                    icon: e.icon,
                    name: e.name,
                    allowToRemoveRecentSearches: v,
                    onResultItemSelect: w,
                    handleRemoveRecentSearch: E,
                    stid: o,
                    value: e.value,
                    subtext: e.subtext,
                    activeSuggestion: -1 !== t && t === a,
                    contentRef: f,
                    historyDetail: R,
                    isNestedChild: s
                  }));
                });
                return a.filter(e => null !== e).length > 0 ? a : null;
              })(e.items);
          }
        })(b);
      return T.createElement(he.UitkSpacing, {
        padding: {
          blockstart: "three"
        }
      }, T.createElement("div", {
        ref: y
      }, I, !D && N, D && T.createElement(de.UitkActionList, {
        "data-stid": o && `${o}-results`
      }, D, L), T.createElement(W.UitkLayoutFlex, {
        justifyContent: "end"
      }, T.createElement(W.UitkLayoutFlexItem, null, T.createElement(ot, {
        results: b
      })))));
    },
    ht = () => T.default.createElement(he.UitkSpacing, {
      margin: {
        block: "eight"
      }
    }, T.default.createElement(me.UitkLineSkeleton, {
      animation: !0,
      type: "primary"
    })),
    mt = () => T.default.createElement(T.default.Fragment, null, Array.from({
      length: 3
    }).map((e, t) => T.default.createElement(ht, {
      key: t
    }))),
    pt = "search-location-input-field",
    gt = e => "heading" in e;
  var yt;
  !function (e) {
    e.TAB = "Tab", e.ESCAPE = "Escape", e.ARROW_UP = "ArrowUp", e.ARROW_DOWN = "ArrowDown", e.ENTER = "Enter", e.BACKSPACE = "Backspace";
  }(yt || (yt = {}));
  const ft = e => {
      const {
          debounceRate: t,
          initialSearchTerm: a,
          isMulti: i,
          adapter: s,
          onResultItemSelect: n,
          label: l,
          value: r,
          allowExactMatch: o,
          categorize: c,
          onClose: d,
          stid: u,
          placeholder: h,
          emptyResultPlaceholder: m,
          listTitle: p,
          handleClear: g,
          dismissButtonText: y,
          clearAllText: f,
          onClearAll: R,
          onItemRemove: v,
          selectedItemHeading: E,
          historyDetail: S,
          required: b,
          allowToRemoveRecentSearches: k,
          searchTermForMultiSelection: I,
          onInputChange: x,
          resultsRequestDurationTimeCallback: A,
          onRecommendationImpression: C,
          predictiveText: U
        } = e,
        {
          formatText: N
        } = (0, V.useLocalization)(),
        L = T.useRef(null),
        D = T.useRef(null),
        z = T.useRef(null),
        [O, M] = T.useState(!1),
        F = "string" == typeof r ? r : "",
        [_, $] = T.useState(a || F || I || ""),
        K = T.useRef(a),
        [Y, j] = T.useState(-1),
        [Q, Z] = T.useState(""),
        [J, X] = T.useState(!1),
        [ee, te] = T.useState([]),
        [ae, ie] = T.useState([]),
        ne = e => {
          L.current && clearTimeout(L.current), (e === null || e === void 0 ? void 0 : e.length) > 0 && (L.current = window.setTimeout(() => {
            const t = _ && _.split(""),
              a = document.activeElement === D.current;
            if (t && e && a) {
              const a = `'${t.join("' , '")} '`;
              (0, w.liveAnnounce)(N("typeahead.announceResults.resultsAvailable", a, e.length));
            }
          }, 1e3));
        },
        re = (e, t, a) => __awaiter(void 0, void 0, void 0, function* () {
          var _a;
          let i, n, l, r;
          K.current = e;
          const o = e,
            d = performance.now();
          if ("" !== o && t) [l, r] = c ? yield Promise.all([s.fetchResultsCategorized(o), s.fetchRecentSearchResultsCategorized()]) : yield Promise.all([s.fetchResults(o), s.fetchRecentSearchResults()]), r && r.length > 0 ? c || gt(r[0]) ? n = r : i = r : c ? n = l : i = l;else if (c) n = yield s.fetchResultsCategorized(o);else if ("" !== o && a) {
            const e = yield s.fetchAlternativeResults(o);
            e && e.length && gt(e[0]) ? n = e : i = e;
          } else {
            const e = yield s.fetchResults(o);
            e && e.length && gt(e[0]) ? n = e : i = e;
          }
          if (A === null || A === void 0 ? void 0 : A(performance.now() - d, "" !== o.trim()), K.current === e) if (i && i.length) {
            if (C === null || C === void 0 ? void 0 : C(t || a ? "" : e), U) {
              const e = $e(o, (_a = i[0]) === null || _a === void 0 ? void 0 : _a.title);
              Z(e);
            }
            te(() => (M(!1), ne(i), i)), ie([]);
          } else n && n.length ? (C === null || C === void 0 ? void 0 : C(t || a ? "" : e), ie(() => {
            M(!1);
            const e = n.flatMap(e => e.typeaheadResults);
            return ne(e), n;
          }), te([])) : (M(!1), te([]), ie([]));
        }),
        oe = t && t > 0 ? (0, P.debounce)(t, re) : re,
        ce = () => {
          Z(""), d === null || d === void 0 ? void 0 : d();
        },
        de = (e, t, a) => {
          var _a;
          (_a = s.onItemSelection) === null || _a === void 0 ? void 0 : _a.call(s, t).then(s => {
            if (i) {
              const t = ee ? se(a) - 1 : 0;
              (0, w.liveAnnounce)(`${N("typeahead.announceResults.itemSelected", e)}\n             ${N("typeahead.announceResults.showingResults", l, t, _)}`), j(-1);
            } else (0, w.liveAnnounce)(`${N("typeahead.announceResults.itemSelected", e)} ${N("typeahead.announceResults.menuClosed")}`), $(e), ce();
            n(e, s, t);
          }).catch(() => {
            re(e, !0, "" !== e), ce();
          });
        },
        ue = () => {
          d === null || d === void 0 ? void 0 : d();
        },
        me = c || ae.length > 0 ? {
          type: "categorized",
          items: ae
        } : {
          type: "uncategorized",
          items: ee
        };
      T.useEffect(() => {
        setTimeout(() => {
          var _a;
          return (_a = D.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 0);
      }, [D]), T.useEffect(() => {
        oe(_, !1, "" !== _);
      }, []);
      const pe = T.createElement(Fe, {
        "data-stid": u && `${u}-input`,
        domRef: D,
        hasClearButton: _.length > 0,
        hasFloatedLabel: !1,
        hasVisibleLabel: !1,
        id: u,
        label: l,
        "aria-label": l,
        onChange: e => __awaiter(void 0, void 0, void 0, function* () {
          const t = e.target.value;
          M(!0), $(t), Z(""), oe(t), x === null || x === void 0 ? void 0 : x(t);
        }),
        onKeyDown: e => {
          switch (e.key) {
            case yt.TAB:
              break;
            case yt.ESCAPE:
              ce();
              break;
            case yt.BACKSPACE:
              X(!1);
              break;
            case yt.ENTER:
              {
                const e = Q.length > 0 && -1 === Y ? le(me, 0) : le(me, Y);
                e ? de(e.value, e.data) : de(_, void 0);
                break;
              }
            case yt.ARROW_UP:
              j(e => {
                const t = 0 === e,
                  {
                    items: a
                  } = me,
                  i = o ? a.length : a.length - 1;
                return t ? i : e - 1;
              });
              break;
            case yt.ARROW_DOWN:
              j(e => {
                const {
                  items: t
                } = me;
                return e >= (o ? t.length : t.length - 1) ? 0 : e + 1;
              });
              break;
            default:
              X(!0);
          }
        },
        placeholder: h,
        value: _,
        handleClear: g,
        required: b,
        autoCapitalize: "off",
        autoComplete: "off",
        autoCorrect: "off",
        type: "text",
        spellCheck: !1,
        predictiveText: J && Q
      });
      return T.createElement(T.Fragment, null, T.createElement(B.Viewport, null, T.createElement(B.ViewSmall, null, T.createElement(q.UitkToolbar, {
        navigationContent: {
          navIconLabel: "Close the dialog",
          onClick: () => {
            d === null || d === void 0 ? void 0 : d();
          },
          navButtonId: `${u}-close`
        }
      }, T.createElement("div", {
        id: pt
      }, pe))), T.createElement(B.ViewLarge, null, T.createElement(rt, {
        type: "sticky",
        position: {
          top: "zero",
          zindex: "layer1"
        }
      }, T.createElement("div", {
        id: pt
      }, pe)))), T.createElement(rt, {
        style: {
          minHeight: "438px"
        }
      }, O ? T.createElement(he.UitkSpacing, {
        padding: {
          inlinestart: "six"
        }
      }, T.createElement("div", null, T.createElement(mt, null))) : T.createElement(ut, {
        typeaheadLabel: l,
        allowExactMatch: o,
        onResultItemSelect: de,
        handleRemoveRecentSearch: e => {
          (e => s.fetchDeleteRecentSearch(e))(e).then(() => {
            const t = ee.filter(t => {
                const a = t.data;
                return (a === null || a === void 0 ? void 0 : a.regionId) === e && "USERHISTORY" === (a === null || a === void 0 ? void 0 : a.category) ? null : t;
              }),
              a = ae.map(t => Object.assign(Object.assign({}, t), {
                typeaheadResults: t.typeaheadResults.filter(t => {
                  const a = t.data;
                  return (a === null || a === void 0 ? void 0 : a.regionId) === e && "USERHISTORY" === (a === null || a === void 0 ? void 0 : a.category) ? null : t;
                })
              }));
            te(t), ie(a);
          });
        },
        results: me,
        searchTerm: _,
        stid: u,
        listTitle: p,
        activeSuggestion: Y,
        emptyResultPlaceholder: m,
        isMulti: i,
        dismissButtonText: y,
        selectedItemHeading: E,
        clearAllText: f,
        onClearAll: R,
        onItemRemove: v,
        value: r,
        domRef: z,
        historyDetail: S,
        allowToRemoveRecentSearches: k
      })), i && T.createElement(B.Viewport, null, T.createElement(B.ViewSmall, null, T.createElement(G.UitkScrim, {
        type: G.UitkScrimType.BUTTON
      }, T.createElement(H.UitkFloatingFullWidthButton, {
        disabled: 0 === (r === null || r === void 0 ? void 0 : r.length),
        onClick: ue,
        isFullWidth: !0
      }, y))), T.createElement(B.ViewLarge, null, T.createElement(he.UitkSpacing, {
        padding: "three",
        style: {
          borderTop: "1px solid #cccfdb"
        }
      }, T.createElement(W.UitkLayoutFlex, {
        justifyContent: "end"
      }, T.createElement(W.UitkLayoutFlexItem, null, T.createElement(H.UitkPrimaryButton, {
        disabled: 0 === (r === null || r === void 0 ? void 0 : r.length),
        onClick: ue
      }, y)))))));
    },
    Rt = T.default.forwardRef((e, t) => {
      const {
          a11yLabel: a,
          searchTerm: i,
          isExpanded: s,
          label: n,
          icon: l,
          invalid: r,
          stid: o,
          onClick: c,
          placeholder: d,
          value: u,
          required: h,
          isMulti: m,
          name: p
        } = e,
        [g, y] = T.default.useState(!1);
      T.default.useEffect(() => {
        y(!0);
      }, []);
      const f = {
        label: n,
        icon: l,
        placeholder: d,
        required: h,
        "aria-label": [a, i].filter(e => e && e.length > 0).join(" "),
        "aria-expanded": s,
        "aria-describedby": r && o ? `${o}-input-error` : void 0,
        "data-stid": `${o}-trigger`,
        onClick: () => {
          c === null || c === void 0 ? void 0 : c();
        },
        value: m ? u.join(", ") : u,
        invalid: r
      };
      return T.default.createElement(T.default.Fragment, null, g && T.default.createElement(K.UitkFakeInput, Object.assign(Object.assign({}, f), {
        domRef: t
      })), T.default.createElement("div", {
        className: g ? "is-hidden" : void 0
      }, T.default.createElement(K.UitkInput, Object.assign(Object.assign({}, f), {
        id: p,
        name: p
      }))));
    }),
    vt = e => {
      var _a;
      const {
          accessibilityLabel: t,
          adapter: a,
          label: i,
          typeaheadPlaceholder: s,
          typeaheadEmptyResultPlaceholder: n,
          dismissButtonText: l,
          isMulti: r,
          onResultSelection: o,
          onUpdate: c,
          handleClear: d,
          value: u,
          id: h,
          onMountCB: m,
          onClick: p,
          onDismiss: g,
          onType: y,
          resultItemImpressionTracker: f,
          onResultItemImpression: R,
          predictiveText: v
        } = e,
        E = (0, V.useLocalization)(),
        [S, b, k] = (0, Xe.useDialog)(`search-location-dialog-${h}`),
        {
          formatText: I
        } = (0, V.useLocalization)(),
        [x, A] = T.default.useState("string" == typeof u ? u : ""),
        [C, U] = T.default.useState(""),
        N = T.default.useRef(),
        L = (e, t, a) => {
          var _a;
          if (c === null || c === void 0 ? void 0 : c({
            selection: {
              term: e,
              data: t
            },
            selectionData: a
          }), o) {
            const a = new CustomEvent("change"),
              i = document.createElement("input");
            i.value = e, i.setAttribute("id", (_a = t === null || t === void 0 ? void 0 : t.id) !== null && _a !== void 0 ? _a : h), i.addEventListener("change", e => {
              o(e);
            }), i.dispatchEvent(a);
          }
          r || (A(e), b.closeDialog());
        },
        D = () => {
          var _a;
          (_a = N.current) === null || _a === void 0 ? void 0 : _a.focus(), b.closeDialog(), A(""), (0, w.liveAnnounce)(I("typeahead.announceResults.menuClosed")), g === null || g === void 0 ? void 0 : g();
        },
        P = t || i,
        z = Object.assign(Object.assign({}, e), {
          label: i,
          onClick: () => {
            b.openDialog();
            const e = x && "" !== x ? x : void 0;
            p === null || p === void 0 ? void 0 : p({
              prefillText: e
            });
          },
          value: u,
          isMulti: !!r,
          a11yLabel: P,
          searchTerm: x,
          isExpanded: S
        }),
        O = Object.assign(Object.assign({}, e), {
          onResultItemSelect: L,
          placeholder: s,
          emptyResultPlaceholder: n,
          onClearAll: d,
          dismissButtonText: l !== null && l !== void 0 ? l : I("typeahead.multiselect.dismiss"),
          historyDetail: a.isHistoryDetailEnabled(),
          isMulti: !!r,
          initialSearchTerm: x,
          onClose: D,
          searchTermForMultiSelection: C,
          onInputChange: e => {
            y === null || y === void 0 ? void 0 : y(e), A(e), U(e);
          },
          onRecommendationImpression: e => {
            R === null || R === void 0 ? void 0 : R(e);
          }
        });
      T.default.useEffect(() => {
        m === null || m === void 0 ? void 0 : m(N);
      }, [m]), T.default.useEffect(() => {
        A("string" == typeof u ? u : "");
      }, [u]), T.default.useEffect(() => {
        a.setL10n(E), a.setTypeaheadCategories();
      }, [a, E]);
      const M = T.default.createElement(Rt, Object.assign(Object.assign({}, z), {
          ref: N
        })),
        F = T.default.createElement(ft, Object.assign({}, O)),
        _ = T.default.useMemo(() => ({
          impressionWrapper: f
        }), [f]);
      return T.default.createElement(fe.Provider, {
        value: _
      }, T.default.createElement(B.Viewport, null, T.default.createElement(B.ViewSmall, null, T.default.createElement(T.default.Fragment, null, M, T.default.createElement(k, null, T.default.createElement(Y.UitkSheetTransition, {
        isVisible: S
      }, T.default.createElement(Y.UitkSheet, {
        isVisible: S,
        type: "full",
        triggerRef: N
      }, F))))), T.default.createElement(B.ViewLarge, null, T.default.createElement(rt, {
        type: "relative"
      }, T.default.createElement("div", null, M, T.default.createElement(Y.UitkSheetTransition, {
        isVisible: S
      }, T.default.createElement(Y.UitkSheet, {
        isVisible: S,
        showOverTrigger: !0,
        disableArrowKeyHandler: !0,
        type: "popover",
        triggerRef: N,
        width: (_a = N.current) === null || _a === void 0 ? void 0 : _a.offsetWidth,
        onDismiss: v ? () => {
          x.length > 0 && (e => __awaiter(void 0, void 0, void 0, function* () {
            return a.fetchResults(e);
          }))(x).then(e => {
            e[0] && "title" in e[0] && L(e[0].title, e[0]);
          }), D();
        } : D
      }, T.default.createElement(Y.UitkSheetContent, {
        padded: !1
      }, F))))))));
    };
})();
var k = b.cV,
  I = b.n7,
  w = b.hI,
  x = b.Le,
  A = b.CG,
  C = b.Ow,
  U = b.r,
  N = b.AI,
  L = b.LG;
export { k as ButtonToggleCustomContent, I as ESSAdapter, w as SingleSelectPillWrapper, x as Sticky, A as TypeaheadCustom, C as TypeaheadCustomWithoutCSS, U as TypeaheadLocationType, N as TypeaheadRenderType, L as ViewRow };